var EstensaModel;
(function (EstensaModel) {
    class ButtonModal {
        visible;
        label;
        tooltip;
        icon;
        value;
        onClick;
        constructor(l, t, v) {
            this.clear();
            this.setInfo(l, t);
            this.value = v;
        }
        clear() {
            this.visible = true;
            this.label = null;
            this.tooltip = null;
            this.icon = null;
            this.value = -1;
            this.onClick = null;
        }
        setInfo(l, t) {
            this.visible = true;
            this.label = l;
            this.tooltip = t;
        }
        isTooltipVisible() {
            return (this.tooltip != null && this.tooltip != undefined && this.tooltip != "");
        }
    }
    EstensaModel.ButtonModal = ButtonModal;
    class BrokerDataFilterBase {
        patientFilter;
        fromDate;
        toDate;
        description;
        isOn;
        modality;
        top;
        typeAssociation;
        constructor() {
            this.clear();
        }
        clear() {
            if (this.patientFilter == null) {
                this.patientFilter = new BrokerDataPatient();
            }
            else {
                this.patientFilter.clear();
            }
            this.fromDate = null;
            this.toDate = null;
            this.description = null;
            this.isOn = null;
            this.modality = null;
            this.top = 200;
            this.typeAssociation = EstensaModel.BrokerTypeFilter.TypeNotAsc;
        }
    }
    class BrokerDataFilterExam extends BrokerDataFilterBase {
        idExam;
        idPacs;
        idStudy;
        constructor() {
            super();
            this.clear();
        }
        clear() {
            super.clear();
            this.idExam = null;
            this.idPacs = null;
            this.idStudy = null;
        }
        setSearchByIdPresList(brokerCheckParams, typeAssociation) {
            this.clear();
            this.typeAssociation = typeAssociation;
            if (brokerCheckParams.idIs) {
                this.isOn = brokerCheckParams.idIs;
            }
            if (brokerCheckParams.idPresList && brokerCheckParams.idPresList.length > 0) {
                this.idExam = "";
                brokerCheckParams.idPresList.forEach((val) => {
                    this.idExam += val + ",";
                });
            }
        }
    }
    EstensaModel.BrokerDataFilterExam = BrokerDataFilterExam;
    class BrokerDataFilterStudy extends BrokerDataFilterBase {
        accessNo;
        idExamsToPre;
        studyId;
        studyInstanceUid;
        constructor() {
            super();
            this.clear();
        }
        clear() {
            super.clear();
            this.accessNo = null;
            this.idExamsToPre = null;
            this.studyId = null;
            this.studyInstanceUid = null;
        }
        setSearchByIdPresList(brokerCheckParams, typeAssociation) {
            this.clear();
            if (brokerCheckParams.idIs) {
                this.isOn = brokerCheckParams.idIs;
            }
            this.typeAssociation = typeAssociation;
            if (this.typeAssociation == EstensaModel.BrokerTypeFilter.TypeAscToPre) {
                if (brokerCheckParams.idPresList && brokerCheckParams.idPresList.length > 0) {
                    this.idExamsToPre = "";
                    brokerCheckParams.idPresList.forEach((val) => {
                        this.idExamsToPre += val + ",";
                    });
                }
            }
            else {
            }
        }
    }
    EstensaModel.BrokerDataFilterStudy = BrokerDataFilterStudy;
    class BrokerDataPatient {
        idPatient;
        cognome;
        nome;
        sesso;
        issuer;
        dataNascita;
        constructor() {
            this.clear();
        }
        clear() {
            this.idPatient = null;
            this.cognome = null;
            this.nome = null;
            this.sesso = null;
            this.issuer = null;
            this.dataNascita = null;
        }
        getPatientFullName() {
            return this.cognome + "^" + this.nome;
        }
    }
    EstensaModel.BrokerDataPatient = BrokerDataPatient;
    class BrokerDataObject {
        patientInfo;
        associated;
        associationType;
        conservabile;
        date;
        description;
        inBroker;
        inTable;
        modality;
        validate;
        constructor() {
            this.clear();
        }
        clear() {
            if (this.patientInfo == null) {
                this.patientInfo = new BrokerDataPatient();
            }
            else {
                this.patientInfo.clear();
            }
            this.associated = null;
            this.associationType = null;
            this.conservabile = null;
            this.date = null;
            this.description = null;
            this.inBroker = null;
            this.inTable = null;
            this.modality = null;
            this.validate = null;
        }
    }
    EstensaModel.BrokerDataObject = BrokerDataObject;
    class BrokerDataStudy extends BrokerDataObject {
        onLocalCD;
        accessionNo;
        availability;
        idExam;
        idPacsAttuale;
        idPacsOriginario;
        idPacsScelto;
        mdi;
        modified;
        modInStudy;
        onBroker;
        removed;
        statoStudio;
        stored;
        studyId;
        studyKeyAttuale;
        studyKeyOriginario;
        studyTime;
        studyUID;
        suspect;
        verified;
        warning;
        workInProgress;
        studyDateAndTime;
        constructor() {
            super();
            this.clear();
        }
        clear() {
            this.onLocalCD = null;
            this.accessionNo = null;
            this.availability = null;
            this.idExam = null;
            this.idPacsAttuale = null;
            this.idPacsOriginario = null;
            this.idPacsScelto = null;
            this.mdi = null;
            this.modified = null;
            this.modInStudy = null;
            this.onBroker = null;
            this.removed = null;
            this.statoStudio = null;
            this.stored = null;
            this.studyId = null;
            this.studyKeyAttuale = null;
            this.studyKeyOriginario = null;
            this.studyTime = null;
            this.studyUID = null;
            this.suspect = null;
            this.verified = null;
            this.warning = null;
            this.workInProgress = null;
            this.studyDateAndTime = null;
        }
    }
    EstensaModel.BrokerDataStudy = BrokerDataStudy;
    class BrokerDataDisplay extends EstensaModel.BrokerDataObject {
        source;
        patientBirthDateFormatted;
        constructor() {
            super();
            this.clear();
        }
        clear() {
            if (this.patientInfo == null) {
                this.patientInfo = new BrokerDataPatient();
            }
            else {
                this.patientInfo.clear();
            }
            this.patientBirthDateFormatted = null;
        }
        setByExam(from) {
            this.patientInfo = angular.copy(from.patientInfo);
            if (!from.patientInfo.dataNascita) {
                this.patientBirthDateFormatted = null;
            }
            else if (typeof (from.patientInfo.dataNascita) == "string") {
                this.patientBirthDateFormatted = new Date(from.patientInfo.dataNascita.toString()).toISOString().split('T')[0];
            }
            else {
                this.patientBirthDateFormatted = from.patientInfo.dataNascita.toISOString().split('T')[0];
            }
            this.date = from.date;
            this.description = from.description;
            this.source = "IS";
        }
        setByStudy(from) {
            this.patientInfo = angular.copy(from.patientInfo);
            if (!from.patientInfo.dataNascita) {
                this.patientBirthDateFormatted = null;
            }
            else if (typeof (from.patientInfo.dataNascita) == "string") {
                this.patientBirthDateFormatted = new Date(from.patientInfo.dataNascita.toString()).toISOString().split('T')[0];
            }
            else {
                this.patientBirthDateFormatted = from.patientInfo.dataNascita.toISOString().split('T')[0];
            }
            this.date = from.date;
            this.description = from.description;
            this.source = "PACS";
        }
    }
    EstensaModel.BrokerDataDisplay = BrokerDataDisplay;
    class BrokerSetAssociationData {
        dataExam;
        dataStudy;
        codeMessageNumber;
        codeMessageString;
        constructor() {
            this.clear();
        }
        clear() {
            this.dataExam = null;
            this.dataStudy = null;
            this.codeMessageNumber = 0;
            this.codeMessageString = null;
        }
    }
    EstensaModel.BrokerSetAssociationData = BrokerSetAssociationData;
    class BrokerManagementParams {
        examsCheckParams;
        isSearchExamHidden;
        clean;
        cleanComeBackStateHistory;
        searchExamData;
        searchStudyData;
        constructor() {
            this.examsCheckParams = new BrokerCheckParams(null, null, false, false, { discardPreviousImages: true, appendToPreviousImages: false, useAlternativeUrl: false });
            this.isSearchExamHidden = false;
            this.searchExamData = new EstensaModel.BrokerDataFilterExam();
            this.searchStudyData = new EstensaModel.BrokerDataFilterStudy();
            this.clean = true;
            this.cleanComeBackStateHistory = true;
        }
        setParamsForCheckBroker(examsCheckParams, bFindStudyAssoc, exams) {
            this.examsCheckParams = angular.copy(examsCheckParams);
            this.isSearchExamHidden = true;
            if (bFindStudyAssoc == true) {
                this.searchExamData.setSearchByIdPresList(examsCheckParams, EstensaModel.BrokerTypeFilter.TypeAsc);
                this.searchStudyData.setSearchByIdPresList(examsCheckParams, EstensaModel.BrokerTypeFilter.TypeAscToPre);
            }
            else {
                this.searchExamData.setSearchByIdPresList(examsCheckParams, EstensaModel.BrokerTypeFilter.All);
                this.searchStudyData.setSearchByIdPresList(examsCheckParams, EstensaModel.BrokerTypeFilter.TypeNotAsc);
                angular.forEach(exams, (exam) => {
                    if (this.searchStudyData.fromDate == null || this.searchStudyData.fromDate > exam.date) {
                        this.searchStudyData.fromDate = exam.date;
                    }
                    if (this.searchStudyData.toDate == null || this.searchStudyData.toDate < exam.date) {
                        this.searchStudyData.toDate = exam.date;
                    }
                });
                angular.forEach(exams, (exam) => {
                    if (this.searchStudyData.modality == null) {
                        this.searchStudyData.modality = exam.modality;
                    }
                    else if (this.searchStudyData.modality != null && this.searchStudyData.modality != exam.modality) {
                        this.searchStudyData.modality = null;
                        return;
                    }
                });
            }
        }
    }
    EstensaModel.BrokerManagementParams = BrokerManagementParams;
    class BrokerCheckParams {
        idPresList;
        idIs;
        isLocked;
        isInteractive;
        openParams;
        credentials;
        constructor(idPresList, idIs, isLocked, isInteractive, openParams, credentials = null) {
            this.idPresList = idPresList;
            this.idIs = idIs;
            this.isLocked = isLocked;
            this.credentials = credentials;
            this.isInteractive = isInteractive;
            this.openParams = openParams;
        }
    }
    EstensaModel.BrokerCheckParams = BrokerCheckParams;
    class BrokerOpenItem {
        patientID;
        accessionNumber;
        imageUrl;
        id;
    }
    EstensaModel.BrokerOpenItem = BrokerOpenItem;
    class BrokerOpenExaminationItem extends BrokerOpenItem {
    }
    EstensaModel.BrokerOpenExaminationItem = BrokerOpenExaminationItem;
    class BrokerOpenEprItem extends BrokerOpenItem {
        idIs;
        isExternal;
        eventId;
        idPres;
    }
    EstensaModel.BrokerOpenEprItem = BrokerOpenEprItem;
    class BrokerOpenImageParamByExaminations {
        init = (brokerExaminations) => {
            this.examinations = [];
            angular.forEach(brokerExaminations, (bExamination) => {
                let examination = {
                    accessionNumber: bExamination.accessionNumber,
                    id: bExamination.id,
                    patient: {
                        identifier: bExamination.patientID
                    },
                    businessUnit: {
                        httpPacs: bExamination.imageUrl
                    }
                };
                this.examinations.push(examination);
            });
        };
        examinations;
        idIs;
        isLocked;
        isInteractive;
        openParams;
    }
    EstensaModel.BrokerOpenImageParamByExaminations = BrokerOpenImageParamByExaminations;
    class BrokerOpenImageParamByEpr {
        init = (brokerEpr) => {
            this.eprEvents = [];
            angular.forEach(brokerEpr, (bEpr) => {
                let epr = {
                    accessionNumber: bEpr.accessionNumber,
                    patient: {
                        identifier: bEpr.patientID
                    },
                    imageUrl: bEpr.imageUrl,
                    idIs: bEpr.idIs,
                    isExternal: bEpr.isExternal,
                    eventId: bEpr.eventId,
                    idPres: bEpr.idPres
                };
                this.eprEvents.push(epr);
            });
        };
        eprEvents;
        credentials;
        openParams;
    }
    EstensaModel.BrokerOpenImageParamByEpr = BrokerOpenImageParamByEpr;
})(EstensaModel || (EstensaModel = {}));
(function (EstensaModel) {
    let FieldType;
    (function (FieldType) {
        FieldType[FieldType["Text"] = 0] = "Text";
        FieldType[FieldType["Combo"] = 1] = "Combo";
        FieldType[FieldType["Label"] = 2] = "Label";
        FieldType[FieldType["Check"] = 3] = "Check";
        FieldType[FieldType["Radio"] = 4] = "Radio";
        FieldType[FieldType["NumericText"] = 5] = "NumericText";
        FieldType[FieldType["DecimalText"] = 6] = "DecimalText";
        FieldType[FieldType["MoneyText"] = 7] = "MoneyText";
        FieldType[FieldType["Date"] = 8] = "Date";
        FieldType[FieldType["TextMultiline"] = 9] = "TextMultiline";
        FieldType[FieldType["TextEditor"] = 10] = "TextEditor";
        FieldType[FieldType["DateTime"] = 11] = "DateTime";
        FieldType[FieldType["ShortNumericText"] = 12] = "ShortNumericText";
        FieldType[FieldType["Time"] = 13] = "Time";
    })(FieldType = EstensaModel.FieldType || (EstensaModel.FieldType = {}));
    let PatientSearchType;
    (function (PatientSearchType) {
        PatientSearchType[PatientSearchType["Default"] = 0] = "Default";
        PatientSearchType[PatientSearchType["Hospitalization"] = 1] = "Hospitalization";
        PatientSearchType[PatientSearchType["External"] = 2] = "External";
    })(PatientSearchType = EstensaModel.PatientSearchType || (EstensaModel.PatientSearchType = {}));
    let BookingStatus;
    (function (BookingStatus) {
        BookingStatus[BookingStatus["Available"] = 0] = "Available";
        BookingStatus[BookingStatus["Unavailable"] = 1] = "Unavailable";
        BookingStatus[BookingStatus["Fill"] = 2] = "Fill";
        BookingStatus[BookingStatus["Lock"] = 3] = "Lock";
    })(BookingStatus = EstensaModel.BookingStatus || (EstensaModel.BookingStatus = {}));
    let BookingType;
    (function (BookingType) {
        BookingType[BookingType["Single"] = 0] = "Single";
        BookingType[BookingType["Start"] = 1] = "Start";
        BookingType[BookingType["Middle"] = 2] = "Middle";
        BookingType[BookingType["End"] = 3] = "End";
    })(BookingType = EstensaModel.BookingType || (EstensaModel.BookingType = {}));
    let DashboardEventType;
    (function (DashboardEventType) {
        DashboardEventType[DashboardEventType["Planned"] = 50] = "Planned";
        DashboardEventType[DashboardEventType["Admitted"] = 100] = "Admitted";
        DashboardEventType[DashboardEventType["Executed"] = 150] = "Executed";
        DashboardEventType[DashboardEventType["Reported"] = 200] = "Reported";
        DashboardEventType[DashboardEventType["Approved"] = 250] = "Approved";
        DashboardEventType[DashboardEventType["Signed"] = 300] = "Signed";
        DashboardEventType[DashboardEventType["OpenedReport"] = 350] = "OpenedReport";
        DashboardEventType[DashboardEventType["OpenedImagesInEmergency"] = 400] = "OpenedImagesInEmergency";
        DashboardEventType[DashboardEventType["DraftOpened"] = 450] = "DraftOpened";
        DashboardEventType[DashboardEventType["CreateDraft"] = 500] = "CreateDraft";
        DashboardEventType[DashboardEventType["DeleteDraft"] = 550] = "DeleteDraft";
    })(DashboardEventType = EstensaModel.DashboardEventType || (EstensaModel.DashboardEventType = {}));
    let MammographicScreeningType;
    (function (MammographicScreeningType) {
        MammographicScreeningType[MammographicScreeningType["Finished"] = 0] = "Finished";
        MammographicScreeningType[MammographicScreeningType["Positive"] = 1] = "Positive";
        MammographicScreeningType[MammographicScreeningType["Negative"] = 2] = "Negative";
        MammographicScreeningType[MammographicScreeningType["NotFinished"] = 3] = "NotFinished";
        MammographicScreeningType[MammographicScreeningType["ReportedSuspended"] = 4] = "ReportedSuspended";
        MammographicScreeningType[MammographicScreeningType["All"] = 5] = "All";
    })(MammographicScreeningType = EstensaModel.MammographicScreeningType || (EstensaModel.MammographicScreeningType = {}));
    let OrderStatus;
    (function (OrderStatus) {
        OrderStatus[OrderStatus["None"] = 0] = "None";
        OrderStatus[OrderStatus["Processed"] = 1] = "Processed";
        OrderStatus[OrderStatus["Reported"] = 2] = "Reported";
        OrderStatus[OrderStatus["Consulted"] = 4] = "Consulted";
    })(OrderStatus = EstensaModel.OrderStatus || (EstensaModel.OrderStatus = {}));
    let SearchTypeForReportWorklist;
    (function (SearchTypeForReportWorklist) {
        SearchTypeForReportWorklist[SearchTypeForReportWorklist["Reporting"] = 0] = "Reporting";
        SearchTypeForReportWorklist[SearchTypeForReportWorklist["Reported"] = 1] = "Reported";
        SearchTypeForReportWorklist[SearchTypeForReportWorklist["Approved"] = 2] = "Approved";
        SearchTypeForReportWorklist[SearchTypeForReportWorklist["All"] = 3] = "All";
    })(SearchTypeForReportWorklist = EstensaModel.SearchTypeForReportWorklist || (EstensaModel.SearchTypeForReportWorklist = {}));
    let SenologyFirstLevelWorklistSearchType;
    (function (SenologyFirstLevelWorklistSearchType) {
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["Reporting"] = 0] = "Reporting";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["Reported"] = 1] = "Reported";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["Completed"] = 2] = "Completed";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["Reviewing"] = 3] = "Reviewing";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["Reviewed"] = 4] = "Reviewed";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["ReportedNotApproved"] = 5] = "ReportedNotApproved";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["ReviewedNotApproved"] = 6] = "ReviewedNotApproved";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["ReportedSuspended"] = 7] = "ReportedSuspended";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["All"] = 8] = "All";
        SenologyFirstLevelWorklistSearchType[SenologyFirstLevelWorklistSearchType["ShowReport"] = 9] = "ShowReport";
    })(SenologyFirstLevelWorklistSearchType = EstensaModel.SenologyFirstLevelWorklistSearchType || (EstensaModel.SenologyFirstLevelWorklistSearchType = {}));
    let SynapseViewMode;
    (function (SynapseViewMode) {
        SynapseViewMode[SynapseViewMode["Patients"] = 0] = "Patients";
        SynapseViewMode[SynapseViewMode["Studies"] = 1] = "Studies";
    })(SynapseViewMode = EstensaModel.SynapseViewMode || (EstensaModel.SynapseViewMode = {}));
    let ImagesInEmergencyButtonsMode;
    (function (ImagesInEmergencyButtonsMode) {
        ImagesInEmergencyButtonsMode[ImagesInEmergencyButtonsMode["Open"] = 0] = "Open";
        ImagesInEmergencyButtonsMode[ImagesInEmergencyButtonsMode["PrintAndOpen"] = 1] = "PrintAndOpen";
    })(ImagesInEmergencyButtonsMode = EstensaModel.ImagesInEmergencyButtonsMode || (EstensaModel.ImagesInEmergencyButtonsMode = {}));
    let UploadingMode;
    (function (UploadingMode) {
        UploadingMode[UploadingMode["Patient"] = 0] = "Patient";
        UploadingMode[UploadingMode["StudyPartial"] = 1] = "StudyPartial";
        UploadingMode[UploadingMode["StudyComplete"] = 2] = "StudyComplete";
    })(UploadingMode = EstensaModel.UploadingMode || (EstensaModel.UploadingMode = {}));
    let DocFamilyType;
    (function (DocFamilyType) {
        DocFamilyType[DocFamilyType["Patient"] = 0] = "Patient";
        DocFamilyType[DocFamilyType["Study"] = 1] = "Study";
    })(DocFamilyType = EstensaModel.DocFamilyType || (EstensaModel.DocFamilyType = {}));
    let OpenReportModeType;
    (function (OpenReportModeType) {
        OpenReportModeType[OpenReportModeType["Standard"] = 0] = "Standard";
        OpenReportModeType[OpenReportModeType["SameIdEvent"] = 1] = "SameIdEvent";
        OpenReportModeType[OpenReportModeType["SameIdEventOnlyNewReport"] = 2] = "SameIdEventOnlyNewReport";
    })(OpenReportModeType = EstensaModel.OpenReportModeType || (EstensaModel.OpenReportModeType = {}));
    let TechnicianMandatoryType;
    (function (TechnicianMandatoryType) {
        TechnicianMandatoryType[TechnicianMandatoryType["Free"] = 0] = "Free";
        TechnicianMandatoryType[TechnicianMandatoryType["Mandatory"] = 1] = "Mandatory";
        TechnicianMandatoryType[TechnicianMandatoryType["Password"] = 2] = "Password";
    })(TechnicianMandatoryType = EstensaModel.TechnicianMandatoryType || (EstensaModel.TechnicianMandatoryType = {}));
    let RequestingPhysicianType;
    (function (RequestingPhysicianType) {
        RequestingPhysicianType[RequestingPhysicianType["RequestingPhysician"] = 0] = "RequestingPhysician";
        RequestingPhysicianType[RequestingPhysicianType["UserRequestingPhysician"] = 1] = "UserRequestingPhysician";
        RequestingPhysicianType[RequestingPhysicianType["FreeRequestingPhysician"] = 2] = "FreeRequestingPhysician";
    })(RequestingPhysicianType = EstensaModel.RequestingPhysicianType || (EstensaModel.RequestingPhysicianType = {}));
    let CaseHistoryProvenanceType;
    (function (CaseHistoryProvenanceType) {
        CaseHistoryProvenanceType[CaseHistoryProvenanceType["External"] = 0] = "External";
        CaseHistoryProvenanceType[CaseHistoryProvenanceType["Internal"] = 1] = "Internal";
    })(CaseHistoryProvenanceType = EstensaModel.CaseHistoryProvenanceType || (EstensaModel.CaseHistoryProvenanceType = {}));
    let SearchMasterDataOrderType;
    (function (SearchMasterDataOrderType) {
        SearchMasterDataOrderType[SearchMasterDataOrderType["Disabled"] = 0] = "Disabled";
        SearchMasterDataOrderType[SearchMasterDataOrderType["IsLocalSearchAfterFirstTimeEnabled"] = 3] = "IsLocalSearchAfterFirstTimeEnabled";
        SearchMasterDataOrderType[SearchMasterDataOrderType["LocalHospitalizationExternal"] = 5] = "LocalHospitalizationExternal";
        SearchMasterDataOrderType[SearchMasterDataOrderType["LocalExternalHospitalization"] = 10] = "LocalExternalHospitalization";
        SearchMasterDataOrderType[SearchMasterDataOrderType["HospitalizationLocalExternal"] = 15] = "HospitalizationLocalExternal";
        SearchMasterDataOrderType[SearchMasterDataOrderType["HospitalizationExternalLocal"] = 20] = "HospitalizationExternalLocal";
        SearchMasterDataOrderType[SearchMasterDataOrderType["ExternalLocalHospitalization"] = 25] = "ExternalLocalHospitalization";
        SearchMasterDataOrderType[SearchMasterDataOrderType["ExternalHospitalizationLocal"] = 30] = "ExternalHospitalizationLocal";
    })(SearchMasterDataOrderType = EstensaModel.SearchMasterDataOrderType || (EstensaModel.SearchMasterDataOrderType = {}));
    let WarningAdmissionType;
    (function (WarningAdmissionType) {
        WarningAdmissionType[WarningAdmissionType["NoWarning"] = 0] = "NoWarning";
        WarningAdmissionType[WarningAdmissionType["WarningOnlySameDay"] = 1] = "WarningOnlySameDay";
        WarningAdmissionType[WarningAdmissionType["WarningOnlySameExams"] = 2] = "WarningOnlySameExams";
    })(WarningAdmissionType = EstensaModel.WarningAdmissionType || (EstensaModel.WarningAdmissionType = {}));
    let LogSeverity;
    (function (LogSeverity) {
        LogSeverity[LogSeverity["Information"] = 0] = "Information";
        LogSeverity[LogSeverity["Warning"] = 1] = "Warning";
        LogSeverity[LogSeverity["Error"] = 2] = "Error";
        LogSeverity[LogSeverity["Critical"] = 3] = "Critical";
        LogSeverity[LogSeverity["Debug"] = 4] = "Debug";
    })(LogSeverity = EstensaModel.LogSeverity || (EstensaModel.LogSeverity = {}));
    let ValidationBeforeSavingType;
    (function (ValidationBeforeSavingType) {
        ValidationBeforeSavingType[ValidationBeforeSavingType["Free"] = 0] = "Free";
        ValidationBeforeSavingType[ValidationBeforeSavingType["WithPassword"] = 1] = "WithPassword";
    })(ValidationBeforeSavingType = EstensaModel.ValidationBeforeSavingType || (EstensaModel.ValidationBeforeSavingType = {}));
    let DeliverabilityResultType;
    (function (DeliverabilityResultType) {
        DeliverabilityResultType[DeliverabilityResultType["Ok"] = 0] = "Ok";
        DeliverabilityResultType[DeliverabilityResultType["ReportNotFound"] = 1] = "ReportNotFound";
        DeliverabilityResultType[DeliverabilityResultType["ReportLocked"] = 2] = "ReportLocked";
        DeliverabilityResultType[DeliverabilityResultType["ReportNotApproved"] = 3] = "ReportNotApproved";
        DeliverabilityResultType[DeliverabilityResultType["ReportAlreadyDelivered"] = 4] = "ReportAlreadyDelivered";
        DeliverabilityResultType[DeliverabilityResultType["DeliveryDataNotComplete"] = 5] = "DeliveryDataNotComplete";
        DeliverabilityResultType[DeliverabilityResultType["GenericError"] = 6] = "GenericError";
    })(DeliverabilityResultType = EstensaModel.DeliverabilityResultType || (EstensaModel.DeliverabilityResultType = {}));
    let DeliverySaveType;
    (function (DeliverySaveType) {
        DeliverySaveType[DeliverySaveType["ByGun"] = 0] = "ByGun";
        DeliverySaveType[DeliverySaveType["ByButton"] = 1] = "ByButton";
    })(DeliverySaveType = EstensaModel.DeliverySaveType || (EstensaModel.DeliverySaveType = {}));
    let Panel;
    (function (Panel) {
        Panel[Panel["Conclusion"] = 0] = "Conclusion";
        Panel[Panel["Finding"] = 1] = "Finding";
        Panel[Panel["Execution"] = 2] = "Execution";
    })(Panel = EstensaModel.Panel || (EstensaModel.Panel = {}));
    let ExamsDescriptionInTextReportType;
    (function (ExamsDescriptionInTextReportType) {
        ExamsDescriptionInTextReportType[ExamsDescriptionInTextReportType["None"] = 0] = "None";
        ExamsDescriptionInTextReportType[ExamsDescriptionInTextReportType["Conclusion"] = 1] = "Conclusion";
        ExamsDescriptionInTextReportType[ExamsDescriptionInTextReportType["Finding"] = 2] = "Finding";
        ExamsDescriptionInTextReportType[ExamsDescriptionInTextReportType["Execution"] = 3] = "Execution";
    })(ExamsDescriptionInTextReportType = EstensaModel.ExamsDescriptionInTextReportType || (EstensaModel.ExamsDescriptionInTextReportType = {}));
    let SearchType;
    (function (SearchType) {
        SearchType[SearchType["CompleteSearchForDay"] = 0] = "CompleteSearchForDay";
        SearchType[SearchType["Patient"] = 1] = "Patient";
        SearchType[SearchType["Date"] = 2] = "Date";
    })(SearchType = EstensaModel.SearchType || (EstensaModel.SearchType = {}));
    let BrokerAssociationType;
    (function (BrokerAssociationType) {
        BrokerAssociationType[BrokerAssociationType["None"] = 0] = "None";
        BrokerAssociationType[BrokerAssociationType["Standard"] = 1] = "Standard";
        BrokerAssociationType[BrokerAssociationType["Estensa"] = 2] = "Estensa";
        BrokerAssociationType[BrokerAssociationType["SenzaAnagrafica"] = 3] = "SenzaAnagrafica";
    })(BrokerAssociationType = EstensaModel.BrokerAssociationType || (EstensaModel.BrokerAssociationType = {}));
    let BrokerTypeFilter;
    (function (BrokerTypeFilter) {
        BrokerTypeFilter[BrokerTypeFilter["TypeNotAsc"] = 0] = "TypeNotAsc";
        BrokerTypeFilter[BrokerTypeFilter["TypeAsc"] = 1] = "TypeAsc";
        BrokerTypeFilter[BrokerTypeFilter["TypeAscToPre"] = 2] = "TypeAscToPre";
        BrokerTypeFilter[BrokerTypeFilter["All"] = 3] = "All";
        BrokerTypeFilter[BrokerTypeFilter["CD"] = 4] = "CD";
    })(BrokerTypeFilter = EstensaModel.BrokerTypeFilter || (EstensaModel.BrokerTypeFilter = {}));
    let SignType;
    (function (SignType) {
        SignType[SignType["CompedDigitalSign"] = 0] = "CompedDigitalSign";
        SignType[SignType["SISSWay"] = 1] = "SISSWay";
        SignType[SignType["SISS"] = 2] = "SISS";
        SignType[SignType["ARUBA"] = 3] = "ARUBA";
        SignType[SignType["InfoCert"] = 4] = "InfoCert";
        SignType[SignType["ScrybaSign"] = 5] = "ScrybaSign";
        SignType[SignType["Confirmo"] = 6] = "Confirmo";
        SignType[SignType["SISSWayCloud"] = 7] = "SISSWayCloud";
        SignType[SignType["SISSCloud"] = 8] = "SISSCloud";
        SignType[SignType["InsielARSS"] = 9] = "InsielARSS";
    })(SignType = EstensaModel.SignType || (EstensaModel.SignType = {}));
    let SourcePublicationType;
    (function (SourcePublicationType) {
        SourcePublicationType[SourcePublicationType["Radio"] = 0] = "Radio";
        SourcePublicationType[SourcePublicationType["Cardio"] = 1] = "Cardio";
        SourcePublicationType[SourcePublicationType["Vna"] = 2] = "Vna";
    })(SourcePublicationType = EstensaModel.SourcePublicationType || (EstensaModel.SourcePublicationType = {}));
    let PublicationStateEnum;
    (function (PublicationStateEnum) {
        PublicationStateEnum[PublicationStateEnum["Published"] = 1] = "Published";
        PublicationStateEnum[PublicationStateEnum["NotPublished"] = 2] = "NotPublished";
        PublicationStateEnum[PublicationStateEnum["Revoked"] = 3] = "Revoked";
        PublicationStateEnum[PublicationStateEnum["Publishing"] = 4] = "Publishing";
        PublicationStateEnum[PublicationStateEnum["Revoking"] = 5] = "Revoking";
    })(PublicationStateEnum = EstensaModel.PublicationStateEnum || (EstensaModel.PublicationStateEnum = {}));
    let ReportValidationType;
    (function (ReportValidationType) {
        ReportValidationType[ReportValidationType["ApproveAndSign"] = 0] = "ApproveAndSign";
        ReportValidationType[ReportValidationType["OnlyApprove"] = 1] = "OnlyApprove";
        ReportValidationType[ReportValidationType["OnlySign"] = 2] = "OnlySign";
    })(ReportValidationType = EstensaModel.ReportValidationType || (EstensaModel.ReportValidationType = {}));
    let FocusOnSearchFilterType;
    (function (FocusOnSearchFilterType) {
        FocusOnSearchFilterType[FocusOnSearchFilterType["None"] = 0] = "None";
        FocusOnSearchFilterType[FocusOnSearchFilterType["LastName"] = 5] = "LastName";
        FocusOnSearchFilterType[FocusOnSearchFilterType["OtherPatientId_FN"] = 10] = "OtherPatientId_FN";
        FocusOnSearchFilterType[FocusOnSearchFilterType["ColumbianBarCode"] = 20] = "ColumbianBarCode";
    })(FocusOnSearchFilterType = EstensaModel.FocusOnSearchFilterType || (EstensaModel.FocusOnSearchFilterType = {}));
    let Html5SpeechMode;
    (function (Html5SpeechMode) {
        Html5SpeechMode[Html5SpeechMode["None"] = -1] = "None";
        Html5SpeechMode[Html5SpeechMode["Recognosco"] = 0] = "Recognosco";
        Html5SpeechMode[Html5SpeechMode["VoiceIn"] = 1] = "VoiceIn";
    })(Html5SpeechMode = EstensaModel.Html5SpeechMode || (EstensaModel.Html5SpeechMode = {}));
    let Html5RecognoscoMode;
    (function (Html5RecognoscoMode) {
        Html5RecognoscoMode[Html5RecognoscoMode["LocalServer"] = 0] = "LocalServer";
        Html5RecognoscoMode[Html5RecognoscoMode["ZeroFootprint"] = 1] = "ZeroFootprint";
    })(Html5RecognoscoMode = EstensaModel.Html5RecognoscoMode || (EstensaModel.Html5RecognoscoMode = {}));
    let MandatoryReviewRulesType;
    (function (MandatoryReviewRulesType) {
        MandatoryReviewRulesType[MandatoryReviewRulesType["Standard"] = 0] = "Standard";
        MandatoryReviewRulesType[MandatoryReviewRulesType["ISPO"] = 1] = "ISPO";
    })(MandatoryReviewRulesType = EstensaModel.MandatoryReviewRulesType || (EstensaModel.MandatoryReviewRulesType = {}));
    let SideType;
    (function (SideType) {
        SideType[SideType["Left"] = 0] = "Left";
        SideType[SideType["Right"] = 1] = "Right";
        SideType[SideType["Bilateral"] = 2] = "Bilateral";
    })(SideType = EstensaModel.SideType || (EstensaModel.SideType = {}));
    let MammographicViewerType;
    (function (MammographicViewerType) {
        MammographicViewerType[MammographicViewerType["None"] = -1] = "None";
        MammographicViewerType[MammographicViewerType["GeSenoIRIS"] = 0] = "GeSenoIRIS";
        MammographicViewerType[MammographicViewerType["Hologic"] = 1] = "Hologic";
        MammographicViewerType[MammographicViewerType["AxonMammo"] = 2] = "AxonMammo";
        MammographicViewerType[MammographicViewerType["EstensaReview"] = 3] = "EstensaReview";
    })(MammographicViewerType = EstensaModel.MammographicViewerType || (EstensaModel.MammographicViewerType = {}));
    let Html5UITheme;
    (function (Html5UITheme) {
        Html5UITheme[Html5UITheme["Dark"] = 0] = "Dark";
        Html5UITheme[Html5UITheme["Light"] = 1] = "Light";
    })(Html5UITheme = EstensaModel.Html5UITheme || (EstensaModel.Html5UITheme = {}));
    let RadiologyViewerType;
    (function (RadiologyViewerType) {
        RadiologyViewerType[RadiologyViewerType["None"] = -1] = "None";
        RadiologyViewerType[RadiologyViewerType["EstensaReview"] = 0] = "EstensaReview";
    })(RadiologyViewerType = EstensaModel.RadiologyViewerType || (EstensaModel.RadiologyViewerType = {}));
    let OsiriXParameterType;
    (function (OsiriXParameterType) {
        OsiriXParameterType[OsiriXParameterType["PatientID"] = 0] = "PatientID";
        OsiriXParameterType[OsiriXParameterType["AccessionNumber"] = 1] = "AccessionNumber";
        OsiriXParameterType[OsiriXParameterType["StudyInstanceUID"] = 2] = "StudyInstanceUID";
    })(OsiriXParameterType = EstensaModel.OsiriXParameterType || (EstensaModel.OsiriXParameterType = {}));
    let ImageActionType;
    (function (ImageActionType) {
        ImageActionType[ImageActionType["Discard"] = 0] = "Discard";
        ImageActionType[ImageActionType["Append"] = 1] = "Append";
        ImageActionType[ImageActionType["Ask"] = 2] = "Ask";
    })(ImageActionType = EstensaModel.ImageActionType || (EstensaModel.ImageActionType = {}));
    let ImpetoExaminationStates;
    (function (ImpetoExaminationStates) {
        ImpetoExaminationStates[ImpetoExaminationStates["ToEnroll"] = 0] = "ToEnroll";
        ImpetoExaminationStates[ImpetoExaminationStates["Enrolled"] = 1] = "Enrolled";
        ImpetoExaminationStates[ImpetoExaminationStates["EnrolledPositive"] = 2] = "EnrolledPositive";
        ImpetoExaminationStates[ImpetoExaminationStates["EnrolledNegative"] = 3] = "EnrolledNegative";
    })(ImpetoExaminationStates = EstensaModel.ImpetoExaminationStates || (EstensaModel.ImpetoExaminationStates = {}));
    let SettingseUnityParameter;
    (function (SettingseUnityParameter) {
        SettingseUnityParameter[SettingseUnityParameter["PatientID"] = 0] = "PatientID";
        SettingseUnityParameter[SettingseUnityParameter["AccessionNumber"] = 1] = "AccessionNumber";
        SettingseUnityParameter[SettingseUnityParameter["StudyInstanceUID"] = 2] = "StudyInstanceUID";
    })(SettingseUnityParameter = EstensaModel.SettingseUnityParameter || (EstensaModel.SettingseUnityParameter = {}));
    let ObscuredTabType;
    (function (ObscuredTabType) {
        ObscuredTabType[ObscuredTabType["None"] = 0] = "None";
        ObscuredTabType[ObscuredTabType["Ambrosiano"] = 1] = "Ambrosiano";
        ObscuredTabType[ObscuredTabType["Euganeo"] = 2] = "Euganeo";
        ObscuredTabType[ObscuredTabType["CustomVisibility"] = 3] = "CustomVisibility";
        ObscuredTabType[ObscuredTabType["FSE20"] = 4] = "FSE20";
    })(ObscuredTabType = EstensaModel.ObscuredTabType || (EstensaModel.ObscuredTabType = {}));
    let ConfidentialityCodeType;
    (function (ConfidentialityCodeType) {
        ConfidentialityCodeType[ConfidentialityCodeType["Normal"] = 0] = "Normal";
        ConfidentialityCodeType[ConfidentialityCodeType["VeryRestricted"] = 1] = "VeryRestricted";
        ConfidentialityCodeType[ConfidentialityCodeType["Restricted"] = 2] = "Restricted";
    })(ConfidentialityCodeType = EstensaModel.ConfidentialityCodeType || (EstensaModel.ConfidentialityCodeType = {}));
    let RemoteReportingAction;
    (function (RemoteReportingAction) {
        RemoteReportingAction[RemoteReportingAction["sendTo"] = 0] = "sendTo";
        RemoteReportingAction[RemoteReportingAction["cancelSendTo"] = 1] = "cancelSendTo";
        RemoteReportingAction[RemoteReportingAction["reSendTo"] = 2] = "reSendTo";
    })(RemoteReportingAction = EstensaModel.RemoteReportingAction || (EstensaModel.RemoteReportingAction = {}));
    let ReasonForStudyEdits;
    (function (ReasonForStudyEdits) {
        ReasonForStudyEdits[ReasonForStudyEdits["onBooking"] = 0] = "onBooking";
        ReasonForStudyEdits[ReasonForStudyEdits["onAdmission"] = 1] = "onAdmission";
        ReasonForStudyEdits[ReasonForStudyEdits["onExecution"] = 2] = "onExecution";
        ReasonForStudyEdits[ReasonForStudyEdits["onReporting"] = 3] = "onReporting";
    })(ReasonForStudyEdits = EstensaModel.ReasonForStudyEdits || (EstensaModel.ReasonForStudyEdits = {}));
    let ReportType;
    (function (ReportType) {
        ReportType[ReportType["SpecialisticReport"] = 0] = "SpecialisticReport";
        ReportType[ReportType["SpecialisticRadiologicalReport"] = 1] = "SpecialisticRadiologicalReport";
        ReportType[ReportType["ClinicalDischargeLetter"] = 2] = "ClinicalDischargeLetter";
        ReportType[ReportType["Unknown"] = 3] = "Unknown";
    })(ReportType = EstensaModel.ReportType || (EstensaModel.ReportType = {}));
    let fileResultType;
    (function (fileResultType) {
        fileResultType[fileResultType["notEvalued"] = 0] = "notEvalued";
        fileResultType[fileResultType["success"] = 1] = "success";
        fileResultType[fileResultType["failed"] = 2] = "failed";
        fileResultType[fileResultType["invalidPath"] = 3] = "invalidPath";
        fileResultType[fileResultType["nullData"] = 4] = "nullData";
        fileResultType[fileResultType["other"] = 5] = "other";
    })(fileResultType = EstensaModel.fileResultType || (EstensaModel.fileResultType = {}));
    let DoseClassConfigurationType;
    (function (DoseClassConfigurationType) {
        DoseClassConfigurationType[DoseClassConfigurationType["NoDMSIntegration"] = 0] = "NoDMSIntegration";
        DoseClassConfigurationType[DoseClassConfigurationType["DMSIntegrationNoBroker"] = 1] = "DMSIntegrationNoBroker";
        DoseClassConfigurationType[DoseClassConfigurationType["DMSIntegrationWithBroker"] = 2] = "DMSIntegrationWithBroker";
    })(DoseClassConfigurationType = EstensaModel.DoseClassConfigurationType || (EstensaModel.DoseClassConfigurationType = {}));
    let DoseConfigurationType;
    (function (DoseConfigurationType) {
        DoseConfigurationType[DoseConfigurationType["Standard"] = 0] = "Standard";
        DoseConfigurationType[DoseConfigurationType["Broker"] = 1] = "Broker";
    })(DoseConfigurationType = EstensaModel.DoseConfigurationType || (EstensaModel.DoseConfigurationType = {}));
    let AggregationType;
    (function (AggregationType) {
        AggregationType[AggregationType["AccessionNumber"] = 0] = "AccessionNumber";
        AggregationType[AggregationType["StudyInstanceUID"] = 1] = "StudyInstanceUID";
    })(AggregationType = EstensaModel.AggregationType || (EstensaModel.AggregationType = {}));
    let ReadingType;
    (function (ReadingType) {
        ReadingType[ReadingType["L1"] = 0] = "L1";
        ReadingType[ReadingType["L2"] = 1] = "L2";
        ReadingType[ReadingType["R"] = 2] = "R";
        ReadingType[ReadingType["All"] = 3] = "All";
    })(ReadingType = EstensaModel.ReadingType || (EstensaModel.ReadingType = {}));
    let AssignationReadType;
    (function (AssignationReadType) {
        AssignationReadType[AssignationReadType["Assign"] = 0] = "Assign";
        AssignationReadType[AssignationReadType["RemoveAssignation"] = 1] = "RemoveAssignation";
        AssignationReadType[AssignationReadType["Reassign"] = 2] = "Reassign";
    })(AssignationReadType = EstensaModel.AssignationReadType || (EstensaModel.AssignationReadType = {}));
    let ReasonAR;
    (function (ReasonAR) {
        ReasonAR[ReasonAR["NO_ERROR"] = 0] = "NO_ERROR";
        ReasonAR[ReasonAR["OTHER_READER_PRESENT"] = 1] = "OTHER_READER_PRESENT";
        ReasonAR[ReasonAR["REPORT_ALREADY_PRESENT"] = 2] = "REPORT_ALREADY_PRESENT";
        ReasonAR[ReasonAR["REVIEWER_NOT_READER"] = 3] = "REVIEWER_NOT_READER";
        ReasonAR[ReasonAR["READING_ALREADY_ASSIGNED"] = 4] = "READING_ALREADY_ASSIGNED";
        ReasonAR[ReasonAR["DB_ERROR"] = 5] = "DB_ERROR";
        ReasonAR[ReasonAR["NO_OPERATION_CHOOSEN"] = 6] = "NO_OPERATION_CHOOSEN";
        ReasonAR[ReasonAR["NO_READER_CHOOSEN"] = 7] = "NO_READER_CHOOSEN";
    })(ReasonAR = EstensaModel.ReasonAR || (EstensaModel.ReasonAR = {}));
    let HealthPlatformOperation;
    (function (HealthPlatformOperation) {
        HealthPlatformOperation["APP_SURVEYS"] = "AppSurveys";
        HealthPlatformOperation["MEASURES"] = "Measures";
        HealthPlatformOperation["MAP"] = "Map";
        HealthPlatformOperation["PRODUCTS"] = "Products";
        HealthPlatformOperation["KIT"] = "Kit";
        HealthPlatformOperation["CALENDAR"] = "Calendar";
        HealthPlatformOperation["THRESHOLDS"] = "Thresholds";
        HealthPlatformOperation["THERAPY"] = "Therapy";
        HealthPlatformOperation["DIARY"] = "Diary";
        HealthPlatformOperation["NURSING_EVALUATION"] = "NursingEvaluation";
        HealthPlatformOperation["EXAMS"] = "Exams";
        HealthPlatformOperation["SURVEYS"] = "Surveys";
        HealthPlatformOperation["TRAINING"] = "Training";
        HealthPlatformOperation["THERAPY_SETTINGS"] = "TherapySettings";
        HealthPlatformOperation["COMPLIANCE_MEASURES"] = "ComplianceMeasures";
        HealthPlatformOperation["DAILY_ECG"] = "DailyECG";
        HealthPlatformOperation["CHAT"] = "Chat";
        HealthPlatformOperation["PERSONAL_DOCUMENT"] = "PersonalDocument";
        HealthPlatformOperation["ALARM"] = "Alarm";
    })(HealthPlatformOperation = EstensaModel.HealthPlatformOperation || (EstensaModel.HealthPlatformOperation = {}));
    let DoseClassEditType;
    (function (DoseClassEditType) {
        DoseClassEditType[DoseClassEditType["NoClass"] = 0] = "NoClass";
        DoseClassEditType[DoseClassEditType["UserEdit"] = 1] = "UserEdit";
        DoseClassEditType[DoseClassEditType["Integration"] = 2] = "Integration";
    })(DoseClassEditType = EstensaModel.DoseClassEditType || (EstensaModel.DoseClassEditType = {}));
    let ReassignResultType;
    (function (ReassignResultType) {
        ReassignResultType[ReassignResultType["NoReassignation"] = 0] = "NoReassignation";
        ReassignResultType[ReassignResultType["None"] = 1] = "None";
        ReassignResultType[ReassignResultType["OnlySome"] = 2] = "OnlySome";
        ReassignResultType[ReassignResultType["All"] = 3] = "All";
    })(ReassignResultType = EstensaModel.ReassignResultType || (EstensaModel.ReassignResultType = {}));
    let PublicationIdentityProvider;
    (function (PublicationIdentityProvider) {
        PublicationIdentityProvider[PublicationIdentityProvider["Classic"] = 0] = "Classic";
        PublicationIdentityProvider[PublicationIdentityProvider["Cognito"] = 1] = "Cognito";
    })(PublicationIdentityProvider = EstensaModel.PublicationIdentityProvider || (EstensaModel.PublicationIdentityProvider = {}));
    let SpecialLaws;
    (function (SpecialLaws) {
        SpecialLaws["drug"] = "drug";
        SpecialLaws["hiv"] = "hiv";
        SpecialLaws["violence"] = "violence";
        SpecialLaws["interruption"] = "interruption";
        SpecialLaws["referringPhysician"] = "referringPhysician";
        SpecialLaws["anonymityBirth"] = "anonymityBirth";
        SpecialLaws["familyCounseling"] = "familyCounseling";
    })(SpecialLaws = EstensaModel.SpecialLaws || (EstensaModel.SpecialLaws = {}));
})(EstensaModel || (EstensaModel = {}));
(function (EstensaModel) {
    let ExternalSignType;
    (function (ExternalSignType) {
        ExternalSignType[ExternalSignType["None"] = 0] = "None";
        ExternalSignType[ExternalSignType["Fuji"] = 1] = "Fuji";
    })(ExternalSignType = EstensaModel.ExternalSignType || (EstensaModel.ExternalSignType = {}));
    let PacsSettingRole;
    (function (PacsSettingRole) {
        PacsSettingRole[PacsSettingRole["OnlyArchive"] = 0] = "OnlyArchive";
        PacsSettingRole[PacsSettingRole["SWFArchive"] = 1] = "SWFArchive";
    })(PacsSettingRole = EstensaModel.PacsSettingRole || (EstensaModel.PacsSettingRole = {}));
    let NREType;
    (function (NREType) {
        NREType[NREType["SISS"] = 0] = "SISS";
        NREType[NREType["SISSWay"] = 1] = "SISSWay";
    })(NREType = EstensaModel.NREType || (EstensaModel.NREType = {}));
    let Html5SSOFlowType;
    (function (Html5SSOFlowType) {
        Html5SSOFlowType[Html5SSOFlowType["Disabled"] = 0] = "Disabled";
        Html5SSOFlowType[Html5SSOFlowType["AuthCode"] = 1] = "AuthCode";
        Html5SSOFlowType[Html5SSOFlowType["AuthCodeWithPkce"] = 2] = "AuthCodeWithPkce";
    })(Html5SSOFlowType = EstensaModel.Html5SSOFlowType || (EstensaModel.Html5SSOFlowType = {}));
    let EWebViewerType;
    (function (EWebViewerType) {
        EWebViewerType["Neologica"] = "Neologica";
        EWebViewerType["Calgary"] = "Calgary";
        EWebViewerType["SecureCalgary"] = "SecureCalgary";
        EWebViewerType["Fuji"] = "Fuji";
        EWebViewerType["Sectra"] = "Sectra";
        EWebViewerType["GenericViewer"] = "GenericViewer";
        EWebViewerType["EstensaReview"] = "EstensaReview";
        EWebViewerType["EstensaReviewVNext"] = "EstensaReviewVNext";
        EWebViewerType["OsiriX"] = "OsiriX";
        EWebViewerType["eUnity"] = "eUnity";
        EWebViewerType["VueMotion"] = "VueMotion";
        EWebViewerType["Synapse7"] = "Synapse7";
        EWebViewerType["Vna"] = "Vna";
        EWebViewerType["SeWebViewer"] = "SeWebViewer";
        EWebViewerType["ZEfiRO"] = "ZEfiRO";
        EWebViewerType["VueClient"] = "VueClient";
        EWebViewerType["Hologic"] = "Hologic";
    })(EWebViewerType = EstensaModel.EWebViewerType || (EstensaModel.EWebViewerType = {}));
    class PacsStudyData {
        accessionNumber;
        dateTime;
        description;
        idPacsScelto;
        imageUrl;
        mdi;
        modality;
        patientBirthDate;
        patientID;
        patientName;
        patientSex;
        studyDateAndTime;
        studyID;
        studyInstanceUID;
        warning;
        constructor() {
            this.clear();
        }
        clear() {
            this.patientName = null;
            this.patientBirthDate = null;
            this.patientSex = null;
            this.patientID = null;
            this.studyInstanceUID = null;
            this.dateTime = null;
            this.description = null;
            this.modality = null;
            this.accessionNumber = null;
            this.studyID = null;
            this.mdi = null;
            this.warning = null;
            this.idPacsScelto = null;
            this.imageUrl = null;
            this.studyDateAndTime = null;
        }
        setByExamination(e) {
            this.patientID = e.patient.identifier;
            this.accessionNumber = e.accessionNumber;
            this.imageUrl = e.businessUnit ? e.businessUnit.httpPacs : '';
            this.studyInstanceUID = e.studyInstanceUID;
        }
        setByEprEvent(e) {
            this.patientID = e.patient.identifier;
            this.accessionNumber = e.accessionNumber;
            this.imageUrl = e.imageUrl;
            this.studyInstanceUID =
                e.pacsStudyData != null && e.pacsStudyData.length > 0 ? e.pacsStudyData[0].studyInstanceUID : null;
        }
        setByVnaItem(vnaItem) {
            this.patientID = vnaItem.patientID;
            this.accessionNumber = vnaItem.accessionNumber;
            this.studyInstanceUID = vnaItem.studyInstanceUID;
        }
        setByBrokerDataStudy(b) {
            this.patientName = b.patientInfo.cognome + '^' + b.patientInfo.nome;
            this.patientBirthDate = b.patientInfo.dataNascita;
            this.patientSex = b.patientInfo.sesso;
            this.patientID = b.patientInfo.idPatient;
            this.description = b.description;
            this.modality = b.modality;
            this.dateTime = b.date;
            this.studyDateAndTime = b.studyDateAndTime;
            this.studyInstanceUID = b.studyUID;
            this.accessionNumber = b.accessionNo;
            this.studyID = b.studyId;
            this.mdi = b.mdi;
            this.warning = b.warning;
            this.idPacsScelto = b.idPacsScelto;
        }
    }
    EstensaModel.PacsStudyData = PacsStudyData;
    class Addendum {
        id;
        date;
        digitallySigner;
        digitallySigningDate;
        isDigitallySigned;
        referringPhysician;
        report;
        secondReferringPhysician;
        user;
    }
    EstensaModel.Addendum = Addendum;
    class NewDefaultReport {
        id;
        code;
        description;
        textPanelDataInfo;
        referringPhysician;
        modalities;
        standardModalities;
        modalitiesDescription;
        standardModalitiesDescription;
        isStandard;
        constructor() {
            this.reset();
        }
        reset() {
            this.id = '';
            this.code = '';
            this.description = '';
            this.referringPhysician = null;
            this.modalities = [];
            this.standardModalities = [];
            this.textPanelDataInfo = null;
            this.isStandard = false;
        }
        getDefaultReport() {
            let defaultReport = {
                id: this.id,
                code: this.code,
                description: this.description,
                referringPhysician: this.referringPhysician,
                modalities: this.modalities,
                standardModalities: this.isStandard ? angular.copy(this.modalities) : [],
                execution: '',
                finding: '',
                conclusion: '',
            };
            switch (this.textPanelDataInfo[0].type) {
                case EstensaModel.Panel.Conclusion:
                    defaultReport.conclusion = this.textPanelDataInfo[0].text;
                    break;
                case EstensaModel.Panel.Execution:
                    defaultReport.execution = this.textPanelDataInfo[0].text;
                    break;
                default:
                    defaultReport.finding = this.textPanelDataInfo[0].text;
                    break;
            }
            switch (this.textPanelDataInfo[1].type) {
                case EstensaModel.Panel.Conclusion:
                    defaultReport.conclusion = this.textPanelDataInfo[1].text;
                    break;
                case EstensaModel.Panel.Execution:
                    defaultReport.execution = this.textPanelDataInfo[1].text;
                    break;
                default:
                    defaultReport.finding = this.textPanelDataInfo[1].text;
                    break;
            }
            switch (this.textPanelDataInfo[2].type) {
                case EstensaModel.Panel.Conclusion:
                    defaultReport.conclusion = this.textPanelDataInfo[2].text;
                    break;
                case EstensaModel.Panel.Execution:
                    defaultReport.execution = this.textPanelDataInfo[2].text;
                    break;
                default:
                    defaultReport.finding = this.textPanelDataInfo[2].text;
                    break;
            }
            this.modalitiesDescription = '';
            if (this.modalities && this.modalities.length > 0) {
                $.each(this.modalities, (n, modality) => {
                    this.modalitiesDescription += modality.description + ', ';
                });
            }
            if (this.modalitiesDescription.length > 0)
                this.modalitiesDescription = this.modalitiesDescription.slice(0, -2);
            return defaultReport;
        }
    }
    EstensaModel.NewDefaultReport = NewDefaultReport;
    let deepeningStatusType;
    (function (deepeningStatusType) {
        deepeningStatusType[deepeningStatusType["UnBooked"] = 0] = "UnBooked";
        deepeningStatusType[deepeningStatusType["Booked"] = 1] = "Booked";
        deepeningStatusType[deepeningStatusType["UnBookable"] = 2] = "UnBookable";
        deepeningStatusType[deepeningStatusType["Refused"] = 3] = "Refused";
    })(deepeningStatusType = EstensaModel.deepeningStatusType || (EstensaModel.deepeningStatusType = {}));
    class DeepeningRefusalReason {
        id;
        description;
    }
    EstensaModel.DeepeningRefusalReason = DeepeningRefusalReason;
    class EnumItem {
        id;
        description;
        constructor(idIn, descIn) {
            this.id = idIn;
            this.description = descIn;
        }
    }
    EstensaModel.EnumItem = EnumItem;
    let SettingsViewerTypeGroup;
    (function (SettingsViewerTypeGroup) {
        SettingsViewerTypeGroup[SettingsViewerTypeGroup["SeveralSettingBox"] = 0] = "SeveralSettingBox";
        SettingsViewerTypeGroup[SettingsViewerTypeGroup["ReportRadio"] = 1] = "ReportRadio";
        SettingsViewerTypeGroup[SettingsViewerTypeGroup["ReportCardio"] = 2] = "ReportCardio";
    })(SettingsViewerTypeGroup = EstensaModel.SettingsViewerTypeGroup || (EstensaModel.SettingsViewerTypeGroup = {}));
    let Cultures;
    (function (Cultures) {
        Cultures[Cultures["italian"] = 0] = "italian";
        Cultures[Cultures["english"] = 1] = "english";
    })(Cultures = EstensaModel.Cultures || (EstensaModel.Cultures = {}));
    let ArrangementType;
    (function (ArrangementType) {
        ArrangementType[ArrangementType["SixXTwo"] = 0] = "SixXTwo";
        ArrangementType[ArrangementType["TwelveXOne"] = 1] = "TwelveXOne";
        ArrangementType[ArrangementType["ThreeXFour"] = 2] = "ThreeXFour";
        ArrangementType[ArrangementType["SixXOnePrecordial"] = 3] = "SixXOnePrecordial";
        ArrangementType[ArrangementType["SixXOnePeripheral"] = 4] = "SixXOnePeripheral";
        ArrangementType[ArrangementType["Medians"] = 5] = "Medians";
    })(ArrangementType = EstensaModel.ArrangementType || (EstensaModel.ArrangementType = {}));
    let TimeAlignment;
    (function (TimeAlignment) {
        TimeAlignment[TimeAlignment["Sequential"] = 0] = "Sequential";
        TimeAlignment[TimeAlignment["Simultaneous"] = 1] = "Simultaneous";
    })(TimeAlignment = EstensaModel.TimeAlignment || (EstensaModel.TimeAlignment = {}));
    let PaperRate;
    (function (PaperRate) {
        PaperRate[PaperRate["mm25"] = 0] = "mm25";
        PaperRate[PaperRate["mm50"] = 1] = "mm50";
    })(PaperRate = EstensaModel.PaperRate || (EstensaModel.PaperRate = {}));
    let Format;
    (function (Format) {
        Format[Format["standard"] = 0] = "standard";
        Format[Format["cabrera"] = 1] = "cabrera";
    })(Format = EstensaModel.Format || (EstensaModel.Format = {}));
    let CaliperMode;
    (function (CaliperMode) {
        CaliperMode[CaliperMode["single"] = 0] = "single";
        CaliperMode[CaliperMode["multi"] = 1] = "multi";
    })(CaliperMode = EstensaModel.CaliperMode || (EstensaModel.CaliperMode = {}));
    class MultiViewerState {
        studySpacing = 0;
    }
    EstensaModel.MultiViewerState = MultiViewerState;
    class ViewerState {
        toolbarVisible = true;
    }
    EstensaModel.ViewerState = ViewerState;
    class ChartState {
        arrangement = ArrangementType.SixXTwo;
        timeAlignment = TimeAlignment.Sequential;
        paperRate = PaperRate.mm25;
        format = Format.standard;
        fiducialPointsVisible = false;
        paperOpacity = 0.5;
        traceSpacing = 0;
        caliperMode = CaliperMode.single;
        zoomFactor;
    }
    EstensaModel.ChartState = ChartState;
    class SummaryState {
        visible = true;
    }
    EstensaModel.SummaryState = SummaryState;
    class EcgState {
        culture = Cultures.english;
        multiViewerState = new MultiViewerState();
        viewerState = new ViewerState();
        chartState = new ChartState();
        summaryState = new SummaryState();
        constructor() { }
    }
    EstensaModel.EcgState = EcgState;
    class PrintFormatParams {
        paperRate = '25';
        gridVisible = 'true';
        format = 'Regular';
        isFormatSupported = true;
        exception = null;
    }
    EstensaModel.PrintFormatParams = PrintFormatParams;
    class ImpetoSurveyData {
        id;
        isEnroled;
        refusalReasons;
    }
    EstensaModel.ImpetoSurveyData = ImpetoSurveyData;
    class VnaItem {
        patientID;
        accessionNumber;
        studyInstanceUID;
    }
    EstensaModel.VnaItem = VnaItem;
    class DeepeningRefusingData {
        idExamination;
        idDeepeningRefusingReason;
    }
    EstensaModel.DeepeningRefusingData = DeepeningRefusingData;
    class MyPebsSurveyAnswer {
        idQuestion;
        value;
    }
    EstensaModel.MyPebsSurveyAnswer = MyPebsSurveyAnswer;
    class MyPebsSurveyData {
        id;
        surveyAnswers;
    }
    EstensaModel.MyPebsSurveyData = MyPebsSurveyData;
    let THIRD_PART_POST_MESSAGES;
    (function (THIRD_PART_POST_MESSAGES) {
        THIRD_PART_POST_MESSAGES["LOAD_CONTEXT_RQ"] = "LoadContextRq";
        THIRD_PART_POST_MESSAGES["LOAD_CONTEXT_RSP"] = "LoadContextRsp";
        THIRD_PART_POST_MESSAGES["CAN_SAVE_CONTEXT_RQ"] = "CanSaveContextRq";
        THIRD_PART_POST_MESSAGES["CAN_SAVE_CONTEXT_RSP"] = "CanSaveContextRsp";
        THIRD_PART_POST_MESSAGES["SAVE_CONTEXT_RQ"] = "SaveContextRq";
        THIRD_PART_POST_MESSAGES["SAVE_CONTEXT_RSP"] = "SaveContextRsp";
        THIRD_PART_POST_MESSAGES["DISCARD_CONTEXT_RQ"] = "DiscardContextRq";
        THIRD_PART_POST_MESSAGES["DISCARD_CONTEXT_RSP"] = "DiscardContextRsp";
        THIRD_PART_POST_MESSAGES["PING"] = "Ping";
        THIRD_PART_POST_MESSAGES["PONG"] = "Pong";
        THIRD_PART_POST_MESSAGES["UNKNOWN"] = "ThirdPartUnknownMessage";
    })(THIRD_PART_POST_MESSAGES = EstensaModel.THIRD_PART_POST_MESSAGES || (EstensaModel.THIRD_PART_POST_MESSAGES = {}));
    let THIRD_PART_STATUS_CODE;
    (function (THIRD_PART_STATUS_CODE) {
        THIRD_PART_STATUS_CODE[THIRD_PART_STATUS_CODE["SUCCESS"] = 0] = "SUCCESS";
        THIRD_PART_STATUS_CODE[THIRD_PART_STATUS_CODE["UNKNOWN"] = -1] = "UNKNOWN";
        THIRD_PART_STATUS_CODE[THIRD_PART_STATUS_CODE["CANNOT_SAVE"] = -2] = "CANNOT_SAVE";
        THIRD_PART_STATUS_CODE[THIRD_PART_STATUS_CODE["CANNOT_DISCARD"] = -3] = "CANNOT_DISCARD";
        THIRD_PART_STATUS_CODE[THIRD_PART_STATUS_CODE["ERROR_CONTEXT_OPEN"] = -4] = "ERROR_CONTEXT_OPEN";
        THIRD_PART_STATUS_CODE[THIRD_PART_STATUS_CODE["ERROR_CONTEXT_LOCKED"] = -5] = "ERROR_CONTEXT_LOCKED";
    })(THIRD_PART_STATUS_CODE = EstensaModel.THIRD_PART_STATUS_CODE || (EstensaModel.THIRD_PART_STATUS_CODE = {}));
    let THIRD_PART_STATUS_DETAIL;
    (function (THIRD_PART_STATUS_DETAIL) {
        THIRD_PART_STATUS_DETAIL["SUCCESS"] = "ThirdPartsSuccessOperation";
        THIRD_PART_STATUS_DETAIL["UNKNOWN"] = "ThirdPartsUnknownMessage";
        THIRD_PART_STATUS_DETAIL["CANNOT_SAVE"] = "ThirdPartsCannotSave";
        THIRD_PART_STATUS_DETAIL["CANNOT_SAVE_INTERNAL"] = "ThirdPartsCannotSaveInternal";
        THIRD_PART_STATUS_DETAIL["CANNOT_DISCARD_INTERNAL"] = "ThirdPartCannotDiscardInterna";
        THIRD_PART_STATUS_DETAIL["CANNOT_LOAD_CONTEXT"] = "ThirdPartCannotLoadContext";
        THIRD_PART_STATUS_DETAIL["CANNOT_LOAD_CONTEXT_OPEN"] = "ThirdPartCannotLoadContextOpen";
        THIRD_PART_STATUS_DETAIL["CANNOT_LOAD_CONTEXT_LOCKED"] = "ThirdPartCannotLoadContextLocked";
    })(THIRD_PART_STATUS_DETAIL = EstensaModel.THIRD_PART_STATUS_DETAIL || (EstensaModel.THIRD_PART_STATUS_DETAIL = {}));
    let AlertModalActionOnClose;
    (function (AlertModalActionOnClose) {
        AlertModalActionOnClose[AlertModalActionOnClose["None"] = 0] = "None";
        AlertModalActionOnClose[AlertModalActionOnClose["RedirectToLoginPage"] = 1] = "RedirectToLoginPage";
        AlertModalActionOnClose[AlertModalActionOnClose["RFC249LocalSearch"] = 2] = "RFC249LocalSearch";
    })(AlertModalActionOnClose = EstensaModel.AlertModalActionOnClose || (EstensaModel.AlertModalActionOnClose = {}));
    let ConsentStatus;
    (function (ConsentStatus) {
        ConsentStatus[ConsentStatus["GREEN"] = 0] = "GREEN";
        ConsentStatus[ConsentStatus["YELLOW"] = 1] = "YELLOW";
        ConsentStatus[ConsentStatus["RED"] = 2] = "RED";
        ConsentStatus[ConsentStatus["GREY"] = 3] = "GREY";
    })(ConsentStatus = EstensaModel.ConsentStatus || (EstensaModel.ConsentStatus = {}));
})(EstensaModel || (EstensaModel = {}));
(function (EstensaModel) {
    let ButtonsTypes;
    (function (ButtonsTypes) {
        ButtonsTypes[ButtonsTypes["dashboard"] = 0] = "dashboard";
        ButtonsTypes[ButtonsTypes["patient"] = 1] = "patient";
        ButtonsTypes[ButtonsTypes["deleteExamination"] = 2] = "deleteExamination";
        ButtonsTypes[ButtonsTypes["patientFolder"] = 3] = "patientFolder";
        ButtonsTypes[ButtonsTypes["unload"] = 4] = "unload";
        ButtonsTypes[ButtonsTypes["images"] = 5] = "images";
        ButtonsTypes[ButtonsTypes["ecgViewer"] = 6] = "ecgViewer";
        ButtonsTypes[ButtonsTypes["questionnaire"] = 7] = "questionnaire";
        ButtonsTypes[ButtonsTypes["addExam"] = 8] = "addExam";
        ButtonsTypes[ButtonsTypes["editExam"] = 9] = "editExam";
        ButtonsTypes[ButtonsTypes["editExamination"] = 10] = "editExamination";
        ButtonsTypes[ButtonsTypes["suspend"] = 11] = "suspend";
        ButtonsTypes[ButtonsTypes["cancelAdmission"] = 12] = "cancelAdmission";
        ButtonsTypes[ButtonsTypes["radiologyAdmission"] = 13] = "radiologyAdmission";
        ButtonsTypes[ButtonsTypes["preAdmission"] = 14] = "preAdmission";
        ButtonsTypes[ButtonsTypes["applyAndPrint"] = 15] = "applyAndPrint";
        ButtonsTypes[ButtonsTypes["undoSuspension"] = 16] = "undoSuspension";
        ButtonsTypes[ButtonsTypes["setTechnician"] = 17] = "setTechnician";
        ButtonsTypes[ButtonsTypes["sendToWorkList"] = 18] = "sendToWorkList";
        ButtonsTypes[ButtonsTypes["execute"] = 19] = "execute";
        ButtonsTypes[ButtonsTypes["undoExecution"] = 20] = "undoExecution";
        ButtonsTypes[ButtonsTypes["printLabels"] = 21] = "printLabels";
        ButtonsTypes[ButtonsTypes["printList"] = 22] = "printList";
        ButtonsTypes[ButtonsTypes["printModules"] = 23] = "printModules";
        ButtonsTypes[ButtonsTypes["attachedDocs"] = 24] = "attachedDocs";
        ButtonsTypes[ButtonsTypes["printReport"] = 25] = "printReport";
        ButtonsTypes[ButtonsTypes["back"] = 26] = "back";
        ButtonsTypes[ButtonsTypes["mergePatient"] = 27] = "mergePatient";
        ButtonsTypes[ButtonsTypes["newOrder"] = 28] = "newOrder";
        ButtonsTypes[ButtonsTypes["orderDetail"] = 29] = "orderDetail";
        ButtonsTypes[ButtonsTypes["modifyOrderBusinessUnit"] = 30] = "modifyOrderBusinessUnit";
        ButtonsTypes[ButtonsTypes["insertOrder"] = 31] = "insertOrder";
        ButtonsTypes[ButtonsTypes["modifyOrder"] = 32] = "modifyOrder";
        ButtonsTypes[ButtonsTypes["deleteOrder"] = 33] = "deleteOrder";
        ButtonsTypes[ButtonsTypes["admissionEvasion"] = 34] = "admissionEvasion";
        ButtonsTypes[ButtonsTypes["bookingEvasion"] = 35] = "bookingEvasion";
        ButtonsTypes[ButtonsTypes["rejection"] = 36] = "rejection";
        ButtonsTypes[ButtonsTypes["undoRejection"] = 37] = "undoRejection";
        ButtonsTypes[ButtonsTypes["assignExam"] = 38] = "assignExam";
        ButtonsTypes[ButtonsTypes["saveExamMods"] = 39] = "saveExamMods";
        ButtonsTypes[ButtonsTypes["saveAdmission"] = 40] = "saveAdmission";
        ButtonsTypes[ButtonsTypes["saveAdmissionAndPrintLabel"] = 41] = "saveAdmissionAndPrintLabel";
        ButtonsTypes[ButtonsTypes["saveAdmissionAndPrintCustomTemplate"] = 42] = "saveAdmissionAndPrintCustomTemplate";
        ButtonsTypes[ButtonsTypes["saveBooking"] = 43] = "saveBooking";
        ButtonsTypes[ButtonsTypes["saveBookingAndGenerateMemorandum"] = 44] = "saveBookingAndGenerateMemorandum";
        ButtonsTypes[ButtonsTypes["anonymous"] = 45] = "anonymous";
        ButtonsTypes[ButtonsTypes["saveModExamination"] = 46] = "saveModExamination";
        ButtonsTypes[ButtonsTypes["saveModExaminationAndPrintPinModule"] = 47] = "saveModExaminationAndPrintPinModule";
        ButtonsTypes[ButtonsTypes["saveModExaminationOnSameAdmission"] = 48] = "saveModExaminationOnSameAdmission";
        ButtonsTypes[ButtonsTypes["saveModExaminationOnSameAdmissionAndPrintPinModule"] = 49] = "saveModExaminationOnSameAdmissionAndPrintPinModule";
        ButtonsTypes[ButtonsTypes["saveModExaminationAndAdmit"] = 50] = "saveModExaminationAndAdmit";
        ButtonsTypes[ButtonsTypes["saveUnload"] = 51] = "saveUnload";
        ButtonsTypes[ButtonsTypes["burn"] = 52] = "burn";
        ButtonsTypes[ButtonsTypes["selectAndBurn"] = 53] = "selectAndBurn";
        ButtonsTypes[ButtonsTypes["print"] = 54] = "print";
        ButtonsTypes[ButtonsTypes["printPreview"] = 55] = "printPreview";
        ButtonsTypes[ButtonsTypes["setDeliverable"] = 56] = "setDeliverable";
        ButtonsTypes[ButtonsTypes["enableWebDelivery"] = 57] = "enableWebDelivery";
        ButtonsTypes[ButtonsTypes["disableWebDelivery"] = 58] = "disableWebDelivery";
        ButtonsTypes[ButtonsTypes["editDeliveryData"] = 59] = "editDeliveryData";
        ButtonsTypes[ButtonsTypes["publish"] = 60] = "publish";
        ButtonsTypes[ButtonsTypes["republish"] = 61] = "republish";
        ButtonsTypes[ButtonsTypes["revokeWebPublication"] = 62] = "revokeWebPublication";
        ButtonsTypes[ButtonsTypes["saveReport"] = 63] = "saveReport";
        ButtonsTypes[ButtonsTypes["approveReport"] = 64] = "approveReport";
        ButtonsTypes[ButtonsTypes["undoApproveReport"] = 65] = "undoApproveReport";
        ButtonsTypes[ButtonsTypes["modifyBooking"] = 66] = "modifyBooking";
        ButtonsTypes[ButtonsTypes["editBooking"] = 67] = "editBooking";
        ButtonsTypes[ButtonsTypes["printMemorandum"] = 68] = "printMemorandum";
        ButtonsTypes[ButtonsTypes["printBookingList"] = 69] = "printBookingList";
        ButtonsTypes[ButtonsTypes["ecgExamFolder"] = 70] = "ecgExamFolder";
        ButtonsTypes[ButtonsTypes["brokerAssociate"] = 71] = "brokerAssociate";
        ButtonsTypes[ButtonsTypes["brokerRemoveAssociation"] = 72] = "brokerRemoveAssociation";
        ButtonsTypes[ButtonsTypes["brokerValidateAssociation"] = 73] = "brokerValidateAssociation";
        ButtonsTypes[ButtonsTypes["storeAvailabilityPrevous"] = 74] = "storeAvailabilityPrevous";
        ButtonsTypes[ButtonsTypes["printMammographicScreening"] = 75] = "printMammographicScreening";
        ButtonsTypes[ButtonsTypes["printListMammographicScreening"] = 76] = "printListMammographicScreening";
        ButtonsTypes[ButtonsTypes["printPreviewActivitiesReport"] = 77] = "printPreviewActivitiesReport";
        ButtonsTypes[ButtonsTypes["printActivitiesReport"] = 78] = "printActivitiesReport";
        ButtonsTypes[ButtonsTypes["radioReadDelete"] = 79] = "radioReadDelete";
        ButtonsTypes[ButtonsTypes["radioReadAssign"] = 80] = "radioReadAssign";
        ButtonsTypes[ButtonsTypes["signReport"] = 81] = "signReport";
        ButtonsTypes[ButtonsTypes["reportShowPdf"] = 82] = "reportShowPdf";
        ButtonsTypes[ButtonsTypes["saveCaseHistory"] = 83] = "saveCaseHistory";
        ButtonsTypes[ButtonsTypes["printCaseHistory"] = 84] = "printCaseHistory";
        ButtonsTypes[ButtonsTypes["reportShowImages"] = 85] = "reportShowImages";
        ButtonsTypes[ButtonsTypes["newReport"] = 86] = "newReport";
        ButtonsTypes[ButtonsTypes["editReport"] = 87] = "editReport";
        ButtonsTypes[ButtonsTypes["saveDeliveryDetails"] = 88] = "saveDeliveryDetails";
        ButtonsTypes[ButtonsTypes["saveDeliveryDetailsAndPrintCustomTemplate"] = 89] = "saveDeliveryDetailsAndPrintCustomTemplate";
        ButtonsTypes[ButtonsTypes["brokerCloseModalOperations"] = 90] = "brokerCloseModalOperations";
        ButtonsTypes[ButtonsTypes["anamnesticDataConsultation"] = 91] = "anamnesticDataConsultation";
        ButtonsTypes[ButtonsTypes["saveQuestionData"] = 92] = "saveQuestionData";
        ButtonsTypes[ButtonsTypes["completeQuestionData"] = 93] = "completeQuestionData";
        ButtonsTypes[ButtonsTypes["printQuestionData"] = 94] = "printQuestionData";
        ButtonsTypes[ButtonsTypes["senologyAnamnesi"] = 95] = "senologyAnamnesi";
        ButtonsTypes[ButtonsTypes["senologyPreviousReport"] = 96] = "senologyPreviousReport";
        ButtonsTypes[ButtonsTypes["senologyPredefinedReport"] = 97] = "senologyPredefinedReport";
        ButtonsTypes[ButtonsTypes["senologyAutoReport"] = 98] = "senologyAutoReport";
        ButtonsTypes[ButtonsTypes["printSenologyWorklist"] = 99] = "printSenologyWorklist";
        ButtonsTypes[ButtonsTypes["printSenologyEpisode"] = 100] = "printSenologyEpisode";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningReading"] = 101] = "firstLevelScreeningReading";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningReadingAll"] = 102] = "firstLevelScreeningReadingAll";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningReview"] = 103] = "firstLevelScreeningReview";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningReviewAll"] = 104] = "firstLevelScreeningReviewAll";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningCheckPending"] = 105] = "firstLevelScreeningCheckPending";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningPreviousReport"] = 106] = "firstLevelScreeningPreviousReport";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningNextReport"] = 107] = "firstLevelScreeningNextReport";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningSaveOK"] = 108] = "firstLevelScreeningSaveOK";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningShowReport"] = 109] = "firstLevelScreeningShowReport";
        ButtonsTypes[ButtonsTypes["firstLevelScreeningUndoApproveForOtherReviewer"] = 110] = "firstLevelScreeningUndoApproveForOtherReviewer";
        ButtonsTypes[ButtonsTypes["auditLogPdfPrint"] = 111] = "auditLogPdfPrint";
        ButtonsTypes[ButtonsTypes["impetoSurvey"] = 112] = "impetoSurvey";
        ButtonsTypes[ButtonsTypes["obscuredData"] = 113] = "obscuredData";
        ButtonsTypes[ButtonsTypes["reSendPin"] = 114] = "reSendPin";
        ButtonsTypes[ButtonsTypes["negativeReport"] = 115] = "negativeReport";
        ButtonsTypes[ButtonsTypes["deepeningRefuse"] = 116] = "deepeningRefuse";
        ButtonsTypes[ButtonsTypes["deepeningUnbookable"] = 117] = "deepeningUnbookable";
        ButtonsTypes[ButtonsTypes["openNewTab"] = 118] = "openNewTab";
        ButtonsTypes[ButtonsTypes["sendToRemoteReporting"] = 119] = "sendToRemoteReporting";
        ButtonsTypes[ButtonsTypes["cancelRemoteReporting"] = 120] = "cancelRemoteReporting";
        ButtonsTypes[ButtonsTypes["reSendToRemoteReporting"] = 121] = "reSendToRemoteReporting";
        ButtonsTypes[ButtonsTypes["myPebsSurvey"] = 122] = "myPebsSurvey";
        ButtonsTypes[ButtonsTypes["newTeleconsultation"] = 123] = "newTeleconsultation";
        ButtonsTypes[ButtonsTypes["editTeleconsultation"] = 124] = "editTeleconsultation";
        ButtonsTypes[ButtonsTypes["editSupplierCenter"] = 125] = "editSupplierCenter";
        ButtonsTypes[ButtonsTypes["feaAuthorizationMngt"] = 126] = "feaAuthorizationMngt";
        ButtonsTypes[ButtonsTypes["feaAuthInsert"] = 127] = "feaAuthInsert";
        ButtonsTypes[ButtonsTypes["feaAuthView"] = 128] = "feaAuthView";
        ButtonsTypes[ButtonsTypes["feaAuthDelete"] = 129] = "feaAuthDelete";
        ButtonsTypes[ButtonsTypes["feaAuthGenerate"] = 130] = "feaAuthGenerate";
        ButtonsTypes[ButtonsTypes["feaAuthCleanGeneration"] = 131] = "feaAuthCleanGeneration";
        ButtonsTypes[ButtonsTypes["editBusinessUnit"] = 132] = "editBusinessUnit";
        ButtonsTypes[ButtonsTypes["viewTeleconsultation"] = 133] = "viewTeleconsultation";
        ButtonsTypes[ButtonsTypes["viewRequest"] = 134] = "viewRequest";
        ButtonsTypes[ButtonsTypes["myPebsUnlock"] = 135] = "myPebsUnlock";
        ButtonsTypes[ButtonsTypes["myPebsRiskCommunication"] = 136] = "myPebsRiskCommunication";
        ButtonsTypes[ButtonsTypes["myPebsRiskUnCommunication"] = 137] = "myPebsRiskUnCommunication";
        ButtonsTypes[ButtonsTypes["feaViewConsent"] = 138] = "feaViewConsent";
        ButtonsTypes[ButtonsTypes["feaViewConsentSigned"] = 139] = "feaViewConsentSigned";
        ButtonsTypes[ButtonsTypes["feaConsentInsert"] = 140] = "feaConsentInsert";
        ButtonsTypes[ButtonsTypes["feaConsentMngmnt"] = 141] = "feaConsentMngmnt";
        ButtonsTypes[ButtonsTypes["feaConsentDelete"] = 142] = "feaConsentDelete";
        ButtonsTypes[ButtonsTypes["validateDeferralReport"] = 143] = "validateDeferralReport";
        ButtonsTypes[ButtonsTypes["undoDeferralReport"] = 144] = "undoDeferralReport";
        ButtonsTypes[ButtonsTypes["refreshView"] = 145] = "refreshView";
        ButtonsTypes[ButtonsTypes["myPebsEditDeepeningRMData"] = 146] = "myPebsEditDeepeningRMData";
        ButtonsTypes[ButtonsTypes["readingReassignment"] = 147] = "readingReassignment";
        ButtonsTypes[ButtonsTypes["radioDeleteReader1"] = 148] = "radioDeleteReader1";
        ButtonsTypes[ButtonsTypes["radioDeleteReader2"] = 149] = "radioDeleteReader2";
        ButtonsTypes[ButtonsTypes["radioDeleteReviewer"] = 150] = "radioDeleteReviewer";
        ButtonsTypes[ButtonsTypes["radioAssignReader1"] = 151] = "radioAssignReader1";
        ButtonsTypes[ButtonsTypes["radioAssignReader2"] = 152] = "radioAssignReader2";
        ButtonsTypes[ButtonsTypes["radioAssignReviewer"] = 153] = "radioAssignReviewer";
        ButtonsTypes[ButtonsTypes["radioReassignReader1"] = 154] = "radioReassignReader1";
        ButtonsTypes[ButtonsTypes["radioReassignReader2"] = 155] = "radioReassignReader2";
        ButtonsTypes[ButtonsTypes["radioReassignReviewer"] = 156] = "radioReassignReviewer";
        ButtonsTypes[ButtonsTypes["undoMergePatient"] = 157] = "undoMergePatient";
        ButtonsTypes[ButtonsTypes["mergeExams"] = 158] = "mergeExams";
        ButtonsTypes[ButtonsTypes["undoMergeExams"] = 159] = "undoMergeExams";
        ButtonsTypes[ButtonsTypes["approveReportAndPrint"] = 160] = "approveReportAndPrint";
        ButtonsTypes[ButtonsTypes["signReportAndPrint"] = 161] = "signReportAndPrint";
        ButtonsTypes[ButtonsTypes["teleconsultation"] = 162] = "teleconsultation";
        ButtonsTypes[ButtonsTypes["unlockMammographicCaseHistory"] = 163] = "unlockMammographicCaseHistory";
        ButtonsTypes[ButtonsTypes["applyNormalValues"] = 164] = "applyNormalValues";
        ButtonsTypes[ButtonsTypes["structuredReportQuestions"] = 165] = "structuredReportQuestions";
        ButtonsTypes[ButtonsTypes["externalLinks"] = 166] = "externalLinks";
        ButtonsTypes[ButtonsTypes["visitType"] = 167] = "visitType";
        ButtonsTypes[ButtonsTypes["forceVisitType"] = 168] = "forceVisitType";
        ButtonsTypes[ButtonsTypes["importVisit"] = 169] = "importVisit";
        ButtonsTypes[ButtonsTypes["dosimetricData"] = 170] = "dosimetricData";
        ButtonsTypes[ButtonsTypes["copy"] = 171] = "copy";
        ButtonsTypes[ButtonsTypes["unlockCD"] = 172] = "unlockCD";
        ButtonsTypes[ButtonsTypes["deleteCD"] = 173] = "deleteCD";
        ButtonsTypes[ButtonsTypes["orderWorklist"] = 174] = "orderWorklist";
        ButtonsTypes[ButtonsTypes["openDiary"] = 175] = "openDiary";
        ButtonsTypes[ButtonsTypes["patientEnrolment"] = 176] = "patientEnrolment";
        ButtonsTypes[ButtonsTypes["monitoringKitAssociation"] = 177] = "monitoringKitAssociation";
        ButtonsTypes[ButtonsTypes["patientCardAndAlarms"] = 178] = "patientCardAndAlarms";
        ButtonsTypes[ButtonsTypes["personalFolder"] = 179] = "personalFolder";
        ButtonsTypes[ButtonsTypes["communication"] = 180] = "communication";
        ButtonsTypes[ButtonsTypes["patientDocument"] = 181] = "patientDocument";
        ButtonsTypes[ButtonsTypes["compileNote"] = 182] = "compileNote";
        ButtonsTypes[ButtonsTypes["printOrder"] = 183] = "printOrder";
        ButtonsTypes[ButtonsTypes["annulmentReport"] = 184] = "annulmentReport";
        ButtonsTypes[ButtonsTypes["reportWithoutTrace"] = 185] = "reportWithoutTrace";
        ButtonsTypes[ButtonsTypes["importNRE"] = 186] = "importNRE";
        ButtonsTypes[ButtonsTypes["undoDeliverability"] = 187] = "undoDeliverability";
        ButtonsTypes[ButtonsTypes["burnOnUsb"] = 188] = "burnOnUsb";
        ButtonsTypes[ButtonsTypes["printOrderList"] = 189] = "printOrderList";
        ButtonsTypes[ButtonsTypes["rejectOrder"] = 190] = "rejectOrder";
        ButtonsTypes[ButtonsTypes["undoRejectOrder"] = 191] = "undoRejectOrder";
        ButtonsTypes[ButtonsTypes["insertOrderAndGenerateMemorandum"] = 192] = "insertOrderAndGenerateMemorandum";
        ButtonsTypes[ButtonsTypes["printEprList"] = 193] = "printEprList";
        ButtonsTypes[ButtonsTypes["printAdmissionList"] = 194] = "printAdmissionList";
        ButtonsTypes[ButtonsTypes["printExecutionList"] = 195] = "printExecutionList";
        ButtonsTypes[ButtonsTypes["radiologyAdmissionAndPrint"] = 196] = "radiologyAdmissionAndPrint";
        ButtonsTypes[ButtonsTypes["viewConsultationRequest"] = 197] = "viewConsultationRequest";
        ButtonsTypes[ButtonsTypes["urlConsultation"] = 198] = "urlConsultation";
        ButtonsTypes[ButtonsTypes["printReportList"] = 199] = "printReportList";
        ButtonsTypes[ButtonsTypes["deferralReports"] = 200] = "deferralReports";
        ButtonsTypes[ButtonsTypes["signSMReport"] = 201] = "signSMReport";
        ButtonsTypes[ButtonsTypes["approveSMReport"] = 202] = "approveSMReport";
        ButtonsTypes[ButtonsTypes["saveSMReport"] = 203] = "saveSMReport";
        ButtonsTypes[ButtonsTypes["undoApproveSMReport"] = 204] = "undoApproveSMReport";
        ButtonsTypes[ButtonsTypes["editSenologyEpisode"] = 205] = "editSenologyEpisode";
        ButtonsTypes[ButtonsTypes["saveSenologyEpisode"] = 206] = "saveSenologyEpisode";
        ButtonsTypes[ButtonsTypes["signSenologyEpisode"] = 207] = "signSenologyEpisode";
        ButtonsTypes[ButtonsTypes["approveSenologyEpisode"] = 208] = "approveSenologyEpisode";
        ButtonsTypes[ButtonsTypes["undoApproveSenologyEpisode"] = 209] = "undoApproveSenologyEpisode";
        ButtonsTypes[ButtonsTypes["copyCD"] = 210] = "copyCD";
        ButtonsTypes[ButtonsTypes["addReportExamination"] = 211] = "addReportExamination";
        ButtonsTypes[ButtonsTypes["deleteReportExamination"] = 212] = "deleteReportExamination";
        ButtonsTypes[ButtonsTypes["viewEquipmentBooking"] = 213] = "viewEquipmentBooking";
        ButtonsTypes[ButtonsTypes["openCollaborationForm"] = 214] = "openCollaborationForm";
        ButtonsTypes[ButtonsTypes["activateCollaboration"] = 215] = "activateCollaboration";
        ButtonsTypes[ButtonsTypes["createMedicalPrescription"] = 216] = "createMedicalPrescription";
        ButtonsTypes[ButtonsTypes["signFeaConsent"] = 217] = "signFeaConsent";
        ButtonsTypes[ButtonsTypes["cancelSignFeaConsent"] = 218] = "cancelSignFeaConsent";
        ButtonsTypes[ButtonsTypes["createRemoteVisit"] = 219] = "createRemoteVisit";
        ButtonsTypes[ButtonsTypes["pendingActivities"] = 220] = "pendingActivities";
        ButtonsTypes[ButtonsTypes["printCertificate"] = 221] = "printCertificate";
        ButtonsTypes[ButtonsTypes["publicationPrintCustomTemplate"] = 222] = "publicationPrintCustomTemplate";
        ButtonsTypes[ButtonsTypes["toolUpload"] = 223] = "toolUpload";
        ButtonsTypes[ButtonsTypes["printOutcome"] = 224] = "printOutcome";
        ButtonsTypes[ButtonsTypes["deleteTeleconsultation"] = 225] = "deleteTeleconsultation";
        ButtonsTypes[ButtonsTypes["cancelTeleconsultation"] = 226] = "cancelTeleconsultation";
        ButtonsTypes[ButtonsTypes["dummyVnex2TestAction"] = 227] = "dummyVnex2TestAction";
        ButtonsTypes[ButtonsTypes["vnaPatientFolder"] = 228] = "vnaPatientFolder";
        ButtonsTypes[ButtonsTypes["toolUploadDicom"] = 229] = "toolUploadDicom";
        ButtonsTypes[ButtonsTypes["importVna"] = 230] = "importVna";
        ButtonsTypes[ButtonsTypes["exeCancel"] = 231] = "exeCancel";
        ButtonsTypes[ButtonsTypes["exeSuspend"] = 232] = "exeSuspend";
        ButtonsTypes[ButtonsTypes["exeExecuteAsLoggedUser"] = 233] = "exeExecuteAsLoggedUser";
        ButtonsTypes[ButtonsTypes["exeExecuteOther"] = 234] = "exeExecuteOther";
        ButtonsTypes[ButtonsTypes["exeUndoExecution"] = 235] = "exeUndoExecution";
        ButtonsTypes[ButtonsTypes["exeChangeTechnician"] = 236] = "exeChangeTechnician";
        ButtonsTypes[ButtonsTypes["regeneratePublicationPwd"] = 237] = "regeneratePublicationPwd";
        ButtonsTypes[ButtonsTypes["deleteReport"] = 238] = "deleteReport";
        ButtonsTypes[ButtonsTypes["directAdmission"] = 239] = "directAdmission";
        ButtonsTypes[ButtonsTypes["patientRegistry"] = 240] = "patientRegistry";
        ButtonsTypes[ButtonsTypes["examManagement"] = 241] = "examManagement";
        ButtonsTypes[ButtonsTypes["viewAnamnesticData"] = 242] = "viewAnamnesticData";
        ButtonsTypes[ButtonsTypes["followUpEnrollmentStart"] = 243] = "followUpEnrollmentStart";
        ButtonsTypes[ButtonsTypes["followUpEnrollmentEdit"] = 244] = "followUpEnrollmentEdit";
        ButtonsTypes[ButtonsTypes["followUpExit"] = 245] = "followUpExit";
        ButtonsTypes[ButtonsTypes["followUpSave"] = 246] = "followUpSave";
        ButtonsTypes[ButtonsTypes["assignEquipment"] = 247] = "assignEquipment";
        ButtonsTypes[ButtonsTypes["addTextPredefined"] = 248] = "addTextPredefined";
        ButtonsTypes[ButtonsTypes["modifyTextPredefined"] = 249] = "modifyTextPredefined";
        ButtonsTypes[ButtonsTypes["deleteTextPredefined"] = 250] = "deleteTextPredefined";
        ButtonsTypes[ButtonsTypes["smIISCDeleteReport"] = 251] = "smIISCDeleteReport";
        ButtonsTypes[ButtonsTypes["communityPrescription"] = 252] = "communityPrescription";
        ButtonsTypes[ButtonsTypes["openResearchArchive"] = 253] = "openResearchArchive";
        ButtonsTypes[ButtonsTypes["reSign"] = 254] = "reSign";
        ButtonsTypes[ButtonsTypes["burnOtherDevice"] = 255] = "burnOtherDevice";
        ButtonsTypes[ButtonsTypes["showFollowUp"] = 256] = "showFollowUp";
        ButtonsTypes[ButtonsTypes["admissionBookedExams"] = 257] = "admissionBookedExams";
        ButtonsTypes[ButtonsTypes["admissionNewExam"] = 258] = "admissionNewExam";
        ButtonsTypes[ButtonsTypes["admissionButton"] = 259] = "admissionButton";
        ButtonsTypes[ButtonsTypes["tooluploadDDevice"] = 260] = "tooluploadDDevice";
    })(ButtonsTypes = EstensaModel.ButtonsTypes || (EstensaModel.ButtonsTypes = {}));
    let SearchPageKeys;
    (function (SearchPageKeys) {
        SearchPageKeys[SearchPageKeys["activitiesReport"] = 1] = "activitiesReport";
        SearchPageKeys[SearchPageKeys["administrativeManagement"] = 2] = "administrativeManagement";
        SearchPageKeys[SearchPageKeys["admissionBooking"] = 3] = "admissionBooking";
        SearchPageKeys[SearchPageKeys["brokerExam"] = 4] = "brokerExam";
        SearchPageKeys[SearchPageKeys["brokerStudy"] = 5] = "brokerStudy";
        SearchPageKeys[SearchPageKeys["cardioEcgFolder"] = 6] = "cardioEcgFolder";
        SearchPageKeys[SearchPageKeys["cdPatientWorklist"] = 7] = "cdPatientWorklist";
        SearchPageKeys[SearchPageKeys["deliverability"] = 8] = "deliverability";
        SearchPageKeys[SearchPageKeys["examAssignmentPatientToMerge"] = 9] = "examAssignmentPatientToMerge";
        SearchPageKeys[SearchPageKeys["examAssignmentPatientIntoMerge"] = 10] = "examAssignmentPatientIntoMerge";
        SearchPageKeys[SearchPageKeys["execution"] = 11] = "execution";
        SearchPageKeys[SearchPageKeys["feaConsentManagement"] = 12] = "feaConsentManagement";
        SearchPageKeys[SearchPageKeys["impetoEnrolment"] = 13] = "impetoEnrolment";
        SearchPageKeys[SearchPageKeys["mammographicScreeningWorklist"] = 14] = "mammographicScreeningWorklist";
        SearchPageKeys[SearchPageKeys["modifyBooking"] = 15] = "modifyBooking";
        SearchPageKeys[SearchPageKeys["myPebsManagement"] = 16] = "myPebsManagement";
        SearchPageKeys[SearchPageKeys["orderManagement"] = 17] = "orderManagement";
        SearchPageKeys[SearchPageKeys["orderSearch"] = 18] = "orderSearch";
        SearchPageKeys[SearchPageKeys["orderWorklist"] = 19] = "orderWorklist";
        SearchPageKeys[SearchPageKeys["patient"] = 20] = "patient";
        SearchPageKeys[SearchPageKeys["patientFolder"] = 21] = "patientFolder";
        SearchPageKeys[SearchPageKeys["patientToMerge"] = 22] = "patientToMerge";
        SearchPageKeys[SearchPageKeys["patientIntoMerge"] = 23] = "patientIntoMerge";
        SearchPageKeys[SearchPageKeys["publicationManagement"] = 24] = "publicationManagement";
        SearchPageKeys[SearchPageKeys["readingReassignment"] = 25] = "readingReassignment";
        SearchPageKeys[SearchPageKeys["reportWorklist"] = 26] = "reportWorklist";
        SearchPageKeys[SearchPageKeys["senologyFirstLevelScreeningWorklist"] = 27] = "senologyFirstLevelScreeningWorklist";
        SearchPageKeys[SearchPageKeys["senologyScreeningWorklist"] = 28] = "senologyScreeningWorklist";
        SearchPageKeys[SearchPageKeys["teleconsultation"] = 29] = "teleconsultation";
        SearchPageKeys[SearchPageKeys["unloadDevice"] = 30] = "unloadDevice";
        SearchPageKeys[SearchPageKeys["deferredReport"] = 31] = "deferredReport";
        SearchPageKeys[SearchPageKeys["deferredReportValidated"] = 32] = "deferredReportValidated";
        SearchPageKeys[SearchPageKeys["readersAssignment"] = 33] = "readersAssignment";
        SearchPageKeys[SearchPageKeys["vnaPatientFolder"] = 34] = "vnaPatientFolder";
        SearchPageKeys[SearchPageKeys["FollowUpList"] = 35] = "FollowUpList";
    })(SearchPageKeys = EstensaModel.SearchPageKeys || (EstensaModel.SearchPageKeys = {}));
    let AgendaTypes;
    (function (AgendaTypes) {
        AgendaTypes[AgendaTypes["multiBooking"] = 0] = "multiBooking";
        AgendaTypes[AgendaTypes["multiSlot"] = 1] = "multiSlot";
    })(AgendaTypes = EstensaModel.AgendaTypes || (EstensaModel.AgendaTypes = {}));
    let MonthViewDayStatus;
    (function (MonthViewDayStatus) {
        MonthViewDayStatus[MonthViewDayStatus["free"] = 0] = "free";
        MonthViewDayStatus[MonthViewDayStatus["occupied"] = 1] = "occupied";
    })(MonthViewDayStatus = EstensaModel.MonthViewDayStatus || (EstensaModel.MonthViewDayStatus = {}));
    let ReportHistoryButtonType;
    (function (ReportHistoryButtonType) {
        ReportHistoryButtonType[ReportHistoryButtonType["reportHistoryShowPdf"] = 0] = "reportHistoryShowPdf";
        ReportHistoryButtonType[ReportHistoryButtonType["reportHistoryShowImages"] = 1] = "reportHistoryShowImages";
        ReportHistoryButtonType[ReportHistoryButtonType["reportHistoryShowReport"] = 2] = "reportHistoryShowReport";
        ReportHistoryButtonType[ReportHistoryButtonType["reportHistoryCopyReport"] = 3] = "reportHistoryCopyReport";
    })(ReportHistoryButtonType = EstensaModel.ReportHistoryButtonType || (EstensaModel.ReportHistoryButtonType = {}));
    let ClinicalHistoryButtonType;
    (function (ClinicalHistoryButtonType) {
        ClinicalHistoryButtonType[ClinicalHistoryButtonType["clinicalHistoryShowPdf"] = 0] = "clinicalHistoryShowPdf";
        ClinicalHistoryButtonType[ClinicalHistoryButtonType["clinicalHistoryShowImages"] = 1] = "clinicalHistoryShowImages";
        ClinicalHistoryButtonType[ClinicalHistoryButtonType["clinicalHistoryShowReportText"] = 2] = "clinicalHistoryShowReportText";
    })(ClinicalHistoryButtonType = EstensaModel.ClinicalHistoryButtonType || (EstensaModel.ClinicalHistoryButtonType = {}));
    let AddendumButtonType;
    (function (AddendumButtonType) {
        AddendumButtonType[AddendumButtonType["newAddendum"] = 0] = "newAddendum";
        AddendumButtonType[AddendumButtonType["removeAddendum"] = 1] = "removeAddendum";
    })(AddendumButtonType = EstensaModel.AddendumButtonType || (EstensaModel.AddendumButtonType = {}));
    let ResizeEventActions;
    (function (ResizeEventActions) {
        ResizeEventActions[ResizeEventActions["ResizeDownGrow"] = 0] = "ResizeDownGrow";
        ResizeEventActions[ResizeEventActions["ResizeDownShrink"] = 1] = "ResizeDownShrink";
        ResizeEventActions[ResizeEventActions["ResizeUpGrow"] = 2] = "ResizeUpGrow";
        ResizeEventActions[ResizeEventActions["ResizeUpShrink"] = 3] = "ResizeUpShrink";
    })(ResizeEventActions = EstensaModel.ResizeEventActions || (EstensaModel.ResizeEventActions = {}));
    let ResponseLockNRE;
    (function (ResponseLockNRE) {
        ResponseLockNRE[ResponseLockNRE["Ok"] = 1] = "Ok";
        ResponseLockNRE[ResponseLockNRE["NoResponse"] = 2] = "NoResponse";
        ResponseLockNRE[ResponseLockNRE["Locked"] = 3] = "Locked";
        ResponseLockNRE[ResponseLockNRE["NreNotAvailable"] = 4] = "NreNotAvailable";
    })(ResponseLockNRE = EstensaModel.ResponseLockNRE || (EstensaModel.ResponseLockNRE = {}));
    let ModifyExaminationToolbarTypes;
    (function (ModifyExaminationToolbarTypes) {
        ModifyExaminationToolbarTypes[ModifyExaminationToolbarTypes["save"] = 0] = "save";
        ModifyExaminationToolbarTypes[ModifyExaminationToolbarTypes["saveSameAdmission"] = 1] = "saveSameAdmission";
        ModifyExaminationToolbarTypes[ModifyExaminationToolbarTypes["saveAndPrintPinModule"] = 2] = "saveAndPrintPinModule";
        ModifyExaminationToolbarTypes[ModifyExaminationToolbarTypes["saveSameAdmissionAndPrintPinModule"] = 3] = "saveSameAdmissionAndPrintPinModule";
    })(ModifyExaminationToolbarTypes = EstensaModel.ModifyExaminationToolbarTypes || (EstensaModel.ModifyExaminationToolbarTypes = {}));
    class ColombianBarCodeData {
        firstName;
        lastName;
        otherPatientId;
        birthDate;
        sex;
        constructor() {
            this.firstName = null;
            this.lastName = null;
            this.otherPatientId = null;
            this.birthDate = null;
            this.sex = null;
        }
    }
    EstensaModel.ColombianBarCodeData = ColombianBarCodeData;
    class KendoGridStateInfo {
        sort;
        selection;
        constructor(selection, sort) {
            this.selection = selection ? selection : undefined;
            this.sort = sort ? sort : undefined;
        }
    }
    EstensaModel.KendoGridStateInfo = KendoGridStateInfo;
})(EstensaModel || (EstensaModel = {}));
var SenologyModel;
(function (SenologyModel) {
    let BusinessUnit;
    (function (BusinessUnit) {
        BusinessUnit[BusinessUnit["II"] = 0] = "II";
        BusinessUnit[BusinessUnit["SC"] = 1] = "SC";
        BusinessUnit[BusinessUnit["I"] = 2] = "I";
    })(BusinessUnit = SenologyModel.BusinessUnit || (SenologyModel.BusinessUnit = {}));
    let EventStatus;
    (function (EventStatus) {
        EventStatus[EventStatus["Reporting"] = 0] = "Reporting";
        EventStatus[EventStatus["Reported"] = 1] = "Reported";
        EventStatus[EventStatus["Approved"] = 2] = "Approved";
        EventStatus[EventStatus["Signed"] = 3] = "Signed";
    })(EventStatus = SenologyModel.EventStatus || (SenologyModel.EventStatus = {}));
    let MammographicScreeningReportStatusType;
    (function (MammographicScreeningReportStatusType) {
        MammographicScreeningReportStatusType[MammographicScreeningReportStatusType["Completed"] = 0] = "Completed";
        MammographicScreeningReportStatusType[MammographicScreeningReportStatusType["Reviewing"] = 1] = "Reviewing";
        MammographicScreeningReportStatusType[MammographicScreeningReportStatusType["Reviewed"] = 2] = "Reviewed";
        MammographicScreeningReportStatusType[MammographicScreeningReportStatusType["Finished"] = 3] = "Finished";
    })(MammographicScreeningReportStatusType = SenologyModel.MammographicScreeningReportStatusType || (SenologyModel.MammographicScreeningReportStatusType = {}));
    class SenologyFirstLevelSchemaPoint {
        left;
        top;
        idPoint;
        side;
    }
    SenologyModel.SenologyFirstLevelSchemaPoint = SenologyFirstLevelSchemaPoint;
    class SenologyFirstLevelSchemaData {
        pointList;
        previewBase64ByteArray;
    }
    SenologyModel.SenologyFirstLevelSchemaData = SenologyFirstLevelSchemaData;
    let WorklistSearchType;
    (function (WorklistSearchType) {
        WorklistSearchType[WorklistSearchType["Reporting"] = 0] = "Reporting";
        WorklistSearchType[WorklistSearchType["Reported"] = 1] = "Reported";
        WorklistSearchType[WorklistSearchType["Approved"] = 2] = "Approved";
        WorklistSearchType[WorklistSearchType["All"] = 3] = "All";
    })(WorklistSearchType = SenologyModel.WorklistSearchType || (SenologyModel.WorklistSearchType = {}));
    let EpisodeStatus;
    (function (EpisodeStatus) {
        EpisodeStatus[EpisodeStatus["Reporting"] = 0] = "Reporting";
        EpisodeStatus[EpisodeStatus["Reported"] = 1] = "Reported";
        EpisodeStatus[EpisodeStatus["Approved"] = 2] = "Approved";
        EpisodeStatus[EpisodeStatus["Signed"] = 3] = "Signed";
    })(EpisodeStatus = SenologyModel.EpisodeStatus || (SenologyModel.EpisodeStatus = {}));
    let ExamType;
    (function (ExamType) {
        ExamType[ExamType["Generic"] = 1] = "Generic";
        ExamType[ExamType["Microbiopsy"] = 2] = "Microbiopsy";
        ExamType[ExamType["Cytology"] = 3] = "Cytology";
        ExamType[ExamType["Neutral"] = 4] = "Neutral";
        ExamType[ExamType["GenericWithoutResult"] = 5] = "GenericWithoutResult";
    })(ExamType = SenologyModel.ExamType || (SenologyModel.ExamType = {}));
    let SideType;
    (function (SideType) {
        SideType[SideType["Left"] = 0] = "Left";
        SideType[SideType["Right"] = 1] = "Right";
        SideType[SideType["Bilateral"] = 2] = "Bilateral";
    })(SideType = SenologyModel.SideType || (SenologyModel.SideType = {}));
    class tbFollowUpActive {
        guid;
        idFollowUp;
        idFollowUpStatus;
        idExitReason;
        idAdvice;
        idAdviceExam;
        tbFollowUpActive() {
            this.guid = null;
            this.idFollowUp = null;
            this.idFollowUpStatus = null;
            this.idExitReason = null;
            this.idAdvice = null;
            this.idAdviceExam = null;
        }
    }
    SenologyModel.tbFollowUpActive = tbFollowUpActive;
    class tbFollowUpGenetic {
        guid;
        idFollowUp;
        idGeneticTestFamily;
        idGeneticRisk;
        idGeneticTestSingle;
        geneticTestSingleDate;
        idNoTestReason;
        geneticVisitDate;
        idCarcinomaPersonalHistory;
        mastectomyDate;
        annexiectomyDate;
        idExitReason;
        familyNumber;
        drPapiNumber;
        mammoFrequency;
        visitFrequency;
        ecoMammoFrequency;
        ecoChestWallFrequency;
        ecoGinecologicFrequency;
        rmMammoFrequency;
        cA125Frequency;
        colonoscopyFrequency;
        startMxAge;
        idNextControlExam;
        tbFollowUpGenetic() {
            this.guid = null;
            this.idFollowUp = null;
            this.idGeneticTestFamily = null;
            this.idGeneticRisk = null;
            this.idGeneticTestSingle = null;
            this.geneticTestSingleDate = null;
            this.idNoTestReason = null;
            this.geneticVisitDate = null;
            this.idCarcinomaPersonalHistory = null;
            this.mastectomyDate = null;
            this.annexiectomyDate = null;
            this.idExitReason = null;
            this.familyNumber = null;
            this.drPapiNumber = null;
            this.cA125Frequency = null;
            this.colonoscopyFrequency = null;
            this.ecoChestWallFrequency = null;
            this.ecoMammoFrequency = null;
            this.mammoFrequency = null;
            this.rmMammoFrequency = null;
            this.visitFrequency = null;
            this.ecoGinecologicFrequency = null;
            this.startMxAge = null;
            this.idNextControlExam = null;
        }
    }
    SenologyModel.tbFollowUpGenetic = tbFollowUpGenetic;
    class tbFollowUp {
        guid;
        idPatient;
        enlistmentDate;
        regimen;
        nextEpisodeDate;
        exitDate;
        news;
        notes;
        isImported;
        lastEpisodeId;
        lastEpisodeData;
        newEpisode;
        notRealFollowUp;
        exitReasonDescription;
        tbFollowUp() {
            this.guid = null;
            this.idPatient = null;
            this.enlistmentDate = null;
            this.regimen = null;
            this.nextEpisodeDate = null;
            this.exitDate = null;
            this.news = null;
            this.notes = null;
            this.isImported = null;
            this.lastEpisodeId = null;
            this.lastEpisodeData = {
                referringPhysician: null,
                examinations: null,
                episodeDate: null,
                adviceExam: null,
                adviceMonth: null,
            };
            this.newEpisode = false;
            this.notRealFollowUp = false;
            this.exitReasonDescription = null;
        }
    }
    SenologyModel.tbFollowUp = tbFollowUp;
    let regimenType;
    (function (regimenType) {
        regimenType[regimenType["senologic"] = 0] = "senologic";
        regimenType[regimenType["genetic"] = 1] = "genetic";
    })(regimenType = SenologyModel.regimenType || (SenologyModel.regimenType = {}));
})(SenologyModel || (SenologyModel = {}));
module.exports = EstensaModel;